import React, { useState, useEffect, useMemo, useRef } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/AppealOnMerits/messages';
import { Container } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/styled-components';
import CorrectionalJudgement from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CorrectionalJudgement';
import {
  JudgementADDDocumentType,
  JudgementOnMeritsVictim,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { pushTo } from 'containers/services/routes-helper';
import {
  ICivilJudgement,
  IJudgementAdd,
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { BUTTON_COLORS, COLORS } from 'constants/design';
import {
  LEGAL_PROCEEDINGS_STEPS,
  PROCEDURE_TYPES,
} from 'containers/LawyerLegalProceedingsPage/constants';
import {
  CONTESTATION,
  CONTESTATION_AGAINST,
  EMPTY_JUDGEMENT_ON_MERITS_DOC,
  PROCEDURE_STEPS,
  EMPTY_INVOICE_INFO,
} from 'containers/data-structure';
import { isAllValuesIsNil } from 'helpers/utils';
import { LISTINGS, PROCEDURE_STATUSES } from 'containers/data-structure';
import SuccessDialog from 'components/SuccessDialog';
import { PAGES } from 'routes';
import { get, isEmpty, isNil } from 'lodash';
import {
  CIVIL_JUDGEMENT_VICTIM_FIELDS,
  COMPTABLE_EXPERTISE_ID,
  JUDGEMENT_EXPERTISE_TYPES,
  JudgementOnMeritsDoc,
  MODE_TYPES,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import CivilJudgementRecap from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap';
import { Config, Listings } from 'containers/AppContainer/typings';
import {
  checkVictimExistanceCivilParty,
  disableValidationButton,
  filterAccountingCivjs,
  formatExpertisesWithExpertReport,
  getInjuredVictims,
  getJudgementOnMeritsVictims,
  getMotifs,
  hasOtherReason,
  isCivilJudgementDefined,
  isContested,
  priorityClaimReason,
  isRejected,
  resolveJudiciaryProcessType,
  resolveStatus,
  getDeceasedVictims,
  disableSharedResponsibility,
  shouldValidateDesceasedVictims,
  getCivjvmInJudgement,
  validateCivilJudgementsOnRecap,
  filterExpertises,
  disableOnValidationButton,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import {
  useBeneficiaries,
  useDahirAmountByVictimKey,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/hooks';
import JudgementOnMeritsInfo from 'containers/LawyerLegalProceedingsPage/AppealOnMerits/JudgementOnMeritsInfo';
import AdditionalInfoJudgementOnMerit from 'containers/LawyerLegalProceedingsPage/AppealOnMerits/AdditionalInfoJudgementOnMerit';
import { ISuedPartyType } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/typings';
import { FormContainer } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/styled-components';
import {
  Checkbox,
  FormControl,
  InputAdornment,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import { isUserActive } from 'containers/common/LegalProceedings/utils';
import DeceasedVictim from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/deceasedVictim';
import JudgementOnMeritsMotifRecap from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/JudgementOnMeritsMotifRecap';
import currentUserStorage from 'containers/services/security/current-user-storage';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import CivilJudgementForm from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementForm';
import {
  formatInvoiceFeeNoteInfos,
  getDeceasedJomVictims,
  getJomVictims,
  getResponsabilityShareJom,
  isDeceasedVictimsOnly,
  getAssignementLawyer,
  formatVictimsToDahirAmount,
  formatNextOfKins,
} from 'containers/LawyerLegalProceedingsPage/utils';
import { toast } from 'react-toastify';
import {
  addAccountingExpertiseAfterMerge,
  addNewCivjJudgement,
  addNewJudgementNonCompensation,
  formatAccExpertises,
  formatMechanicalExpertises,
  formatMedExpertises,
  getAllBeneficiaries,
  getCivilJudgement,
  getDeceasedVictim,
  updateVehicleAccountingExpertiseAfterMerge,
} from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/utils';
import JudgementOnMeritsForm from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/JudgementOnMeritsForm';
import AdditionalInfoJudgementOnMeritForm from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/AdditionalInfoJudgementOnMeritsForm';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { useSelector } from 'react-redux';
import InvoiceFeeNotesManagerDialog from 'components/InvoiceFeeNoteDialog/InvoiceFeeNotesManagerDialog';
import { INCIDENT_TYPE } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/constants';
import { mergeEvaluationsV2 } from 'containers/CourtManagerLegalProceedings/ExpertReport/utils';
import {
  getAppealAddDocument,
  isExpertReportWithoutDecision,
} from 'containers/CourtManagerLegalProceedings/AppealOnMerits/utils';
import InjuredVictim from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/injuredVictim';
import {
  formatFeeNote,
  getJudgementAddDocuments,
  renderButtonValidationTitle,
  resolveJudgementAddAppeal,
  renderMessageFormReference,
  mapVictimToJudiciaryEvaluation,
  mapSagisEvaluationsWithoutExpertise,
  mapSagisEvaluations,
  mapReasonWithoutCompensationEvaluations,
  mapCivilDocumentsEvaluations,
  getFeeNoteAssignment,
} from 'containers/LawyerLegalProceedingsPage/AppealOnMerits/utils';
import { getIntervenantInfo } from 'containers/LawyerLegalProceedingsPage/utils';
import SahamDrawer from 'components/SahamDrawer';
import { getVictimFullName } from 'containers/LawyerLegalProceedingsPage/judgementAppeal/CivilJudgement/Expertises/utils';
import moment from 'moment';
import FirmReferenceForm from 'components/FirmReferenceForm';
import { getVictimFromSagisInfo } from 'containers/PreOpeningPage/utils';
import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';
import {
  formatCourtFileNumber,
  getPendingFeeNotesByStep,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import { resolveSagisClaim } from 'helpers/utils';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/constants';
import {
  extractIntervenant,
  formatIntervenants,
} from 'containers/RecapPage/utils';
import DynamiqDialog from 'components/InvoiceFeeNoteDialog/DynamiqDialog';
import InvoiceFeeNoteDialog from 'components/InvoiceFeeNoteDialog';
import InvoiceInfoDialog from 'components/InvoiceFeeNoteDialog/InvoiceInfoDialog';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { CIVIL_JUDGEMENT_TYPES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/constants';
import InjuredVictimsRecap from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/InjuredVictimsRecap';
import { isBlockStatusClaim } from 'containers/CourtManagerLegalProceedings/utils';
import { FeeNoteType, VictimType } from 'typings/globalTypes';
import {
  getLimitInvoiceIntervenant,
  getLimitInvoiceManager,
} from 'services/utils';
import { makeSelectFeeNotes } from 'containers/LawyerFeeNote/selectors';

export interface JudgementOnMeritsAppealProps {
  intl: IntlShape;
  listings: Listings;
  judgementAddDocuments: JudgementADDDocumentType[];
  uploadDocument: Function;
  setDocumentId: Function;
  documentId: string;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  requestCreateJudgementOnMerits: Function;
  judgementOnMerits: JudgementOnMeritsType;
  claimId: number;
  claimNumber: string;
  requestGetDahirAmount: Function;
  dahirAmount: [];
  judgementAdd: any;
  judgementAddClone: IJudgementAdd | {};
  policyInfo: { sagis: {} };
  judiciaryProcessId: number;
  civilProceeding: any;
  isManager: boolean;
  isCivilProceeding: boolean;
  requestGetJudgementAdd: Function;
  judgementAddAppeal: any;
  requestGetJudgementAddAppeal: Function;
  victims: VictimType[];
  requestAddJudgementOnMeritsSupportDocument: Function;
  requestValidateJudgementOnMerits?: Function;
  expertiseReport?: any;
  expertiseRaportAppeal?: any;
  claim?: any;
  vehicules?: any;
  currentJudiciaryProcess?: any;
  currentJom?: any;
  isMultiple?: boolean | undefined;
  jomDeceasedVictims?: any;
  isFirst?: boolean;
  requestGetExpertiseReport?: Function;
  requestGetExpertiseReportAppeal?: Function;
  isAssignedLawyer: boolean;
  setDialogOpenFirmReference?: Function;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  setIsButtonRedirect?: Function;
  appealOnMeritsMultiple?: any;
  imagineDocuments: any;
  isConsultation: boolean;
  requestGetDocByDocumentumId: Function;
}

export const JudgementOnMeritsAppeal: React.FC<JudgementOnMeritsAppealProps> = ({
  uploadDocument,
  listings,
  uploadedDocument,
  resetUploadedDocument,
  documentId,
  judgementAddDocuments,
  setDocumentId,
  requestCreateJudgementOnMerits,
  judgementOnMerits,
  claimId,
  claimNumber,
  dahirAmount,
  judgementAddAppeal,
  requestValidateJudgementOnMerits,
  currentJudiciaryProcess,
  currentJom,
  isMultiple,
  jomDeceasedVictims,
  isFirst,
  setIsButtonRedirect,
  ...props
}): JSX.Element => {
  const [judgement, setJudgement] = useState({} as any);
  const [sharedResponsability, setSharedResponsability] = useState<string>('');
  const [generateFeeNoteLawyer, setGenerateFeeNoteLawyer] = React.useState<
    boolean
  >(false);
  const [
    openInvoiceUpdateFeeNoteInfoDialog,
    setOpenInvoiceUpdateFeeNoteInfoDialog,
  ] = React.useState(false);
  const currentFeeNoteIndexRef = useRef<number>(0);
  const [currentFeeNoteIndex, setCurrentFeeNoteIndex] = useState<number | null>(
    null,
  );
  const [invoiceFeeNotes, setInvoiceFeeNotes] = useState([]);

  const [openInvoiceInfoLawyers, setOpenInvoiceInfoLawyers] = React.useState<
    boolean
  >(false);
  const [invoiceFeeNoteInfos, setInvoiceFeeNoteInfo] = React.useState<any>([]);

  const filtredCvilProceeding = props.civilProceeding.find(
    (element: { id: number }) => element.id === props.judiciaryProcessId,
  );
  const claimAssignment = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'assignment'], []),
  );
  const assignedLawyersByJudiciaryProcess = claimAssignment.filter(
    (el: any) =>
      el.judiciaryProcessId === props.judiciaryProcessId &&
      el.isDeleted === false,
  );
  const allJudgementDocuments = useMemo(
    () =>
      resolveJudgementAddAppeal(
        getJudgementAddDocuments(
          judgementAddDocuments,
          get(judgementAddAppeal, 'judgementAddDocuments', []),
          judgementOnMerits,
        ),
        false,
        null,
      ),
    [judgementAddDocuments, judgementAddAppeal, judgementOnMerits],
  );

  const lawyerAssignment = getAssignementLawyer(
    claimAssignment,
    props.judiciaryProcessId,
  );
  const [
    decisionGenerationFeeNote,
    setDecisionGenerationFeeNote,
  ] = React.useState(null);
  const [
    openInvoiceFeeNoteInfoDialog,
    setOpenInvoiceFeeNoteInfoDialog,
  ] = React.useState(false);
  const [invoiceDocument, setInvoiceDocument] = React.useState({});
  const [invoiceNumber, setInvoiceNumber] = React.useState(null);
  const [invoiceDate, setInvoiceDate] = React.useState(null);

  const lawyerFirmReference = get(lawyerAssignment, 'firmReference', null);

  const lawyerAssignmentDate = get(
    lawyerAssignment,
    'lawyerAssignmentDate',
    get(lawyerAssignment, 'createdAt', null),
  );

  const claimFeeNotes = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'feeNotes'], []),
  );
  const feeNotesStore = useSelector(makeSelectFeeNotes());

  const feeNoteAssignment = getFeeNoteAssignment(
    claimFeeNotes,
    judgementOnMerits,
  );
  const feeNotes = getPendingFeeNotesByStep(
    feeNotesStore,
    PROCEDURE_STEPS.ARRET_ON_MERITS,
    get(judgementOnMerits, 'judgementOnMerits.id'),
    [],
    currentIntervenantStorage?.get()?.sagis_code,
  );

  const [judgementOnMeritsRequest, setJudgementOnMeritsRequest] = useState({
    document: null,
    cj: {
      suedPartys: [],
    },
    civjs: [],
    civjvm: [],
    civjVehicle: get(
      judgementOnMerits,
      'judgementOnMerits.jom.civjVehicle',
      [],
    ),
    jmv: get(judgementOnMerits, 'judgementOnMerits.jom.jmv', []),
  });

  const [isSuccessPopinOpen, setIsSuccessPopinOpen] = useState<boolean>(false);

  const [dahirAmountByVictimKey] = useDahirAmountByVictimKey(
    props.victims
      .filter(
        (item: any) =>
          item.injuryPostKey === INJURY_POST_DECEASED &&
          !isEmpty(item?.victimKey),
      )
      .map((item: any) => item.victimKey),
    judgementAddDocuments,
    dahirAmount,
    judgementAddAppeal,
    props.victims
      .filter(
        (item: any) =>
          item.injuryPostKey !== INJURY_POST_DECEASED &&
          !isEmpty(item?.victimKey),
      )
      .map((item: any) => item.victimKey),
  );
  const [isCJDisabled, setIsCJDisabled] = useState({});
  const civilJudgementVictims = get(
    judgementOnMerits,
    'judgementOnMerits.jom.civjvm',
    [],
  ).filter((item: any) => !item?.expertiseJudgementAddDocumentId);
  const [victims, setVictims] = useState([]);
  const [lawyerFirmRef, setLawyerFirmRef] = React.useState(null);
  const [civilJudgements, setCivilJudgements] = useState([]);
  useEffect(() => {
    setCivilJudgements([...getCivilJudgement(judgementOnMerits)] as any);
    setSharedResponsability(getResponsabilityShareJom(judgementOnMerits));
  }, [judgementOnMerits]);
  const lawyerInfo = getIntervenantInfo();
  const [judgementOnMeritsInfoForm, setJudgementOnMeritsInfoForm] = useState(
    {},
  );

  const [
    correctionalJudgementOnMeritsForm,
    setCorrectionalJudgementOnMeritsForm,
  ] = useState<any>([]);

  const [civilJudgementOnMeritsForm, setCivilJudgementOnMeritsForm] = useState<
    any
  >([]);

  const [
    civilJudgementOnMeritsFormMedicalExpertise,
    setCivilJudgementOnMeritsFormMedicalExpertise,
  ] = useState<any>([]);

  const priorityReasonClaimId = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'priorityReasonId']),
  );
  const claimRecap = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap']),
  );
  const [
    civilJudgementOnMeritsFormAccountingExpertise,
    setCivilJudgementOnMeritsFormAccountingExpertise,
  ] = useState<any>([]);

  const [
    civilJudgementOnMeritsFormMechanicalExpertise,
    setCivilJudgementOnMeritsFormMechanicalExpertise,
  ] = useState<any>([]);

  const [
    additionalJudgementOnMeritsInfoForm,
    setAdditionalJudgementOnMeritsInfoForm,
  ] = useState({});

  const [responsibilityRate, setResponsibilityRate] = useState(
    get(
      judgementOnMerits,
      '[judgementOnMerits][jom][civjs][0][responsibilityShare]',
      null,
    ),
  );
  const [beneficiaries, setBeneficiaries] = useBeneficiaries(
    judgementOnMerits,
    judgementAddAppeal,
    [...get(props, 'jomDeceasedVictims', [])],
    dahirAmountByVictimKey,
    getDeceasedVictims(
      props.judgementAddClone,
      judgementAddAppeal,
      filtredCvilProceeding,
    ),
    isMultiple,
  );

  const [civjvmRequest, setCivjvmRequest] = useState(
    get(judgementOnMerits, 'judgementOnMerits.jom.civjvm', []),
  );

  useEffect(() => {
    props.requestGetDahirAmount(
      get(formatVictimsToDahirAmount(get(props, 'victims', [])), 'injured', []),
      get(
        formatVictimsToDahirAmount(get(props, 'victims', [])),
        'deceased',
        [],
      ),
    );
  }, []);
  useEffect(() => {
    if (props.isManager) {
      if (
        !isEmpty(
          extractIntervenant(
            get(listings, 'intervenants'),
            assignedLawyersByJudiciaryProcess,
          ),
        )
      ) {
        setInvoiceFeeNoteInfo(
          extractIntervenant(
            get(listings, 'intervenants'),
            assignedLawyersByJudiciaryProcess,
          ).map((item: any, index: any) => ({
            codeIntervenant: item.ItemKey,
            createdBy:
              currentUserStorage?.get() && currentUserStorage?.get().username,
            ...EMPTY_INVOICE_INFO,
          })),
        );
      }
    }
  }, [props.judiciaryProcessId, currentJudiciaryProcess, !claimAssignment]);

  useEffect(() => {
    props.requestGetJudgementAddAppeal(
      claimId,
      PROCEDURE_TYPES.FIRST_INSTANCE,
      props.judiciaryProcessId,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.judiciaryProcessId, claimId]);

  const handleSuedPartiesChange = (suedParties: ISuedPartyType[]) =>
    setJudgementOnMeritsRequest(
      Object.assign(
        {},
        { ...judgementOnMeritsRequest },
        {
          cj: {
            suedPartys: suedParties,
          },
        },
      ),
    );

  const handleCorrectionalCondamnationChange = (id: number | undefined) => (
    e: React.ChangeEvent<{ value: string }>,
  ) => {
    const found = correctionalJudgementOnMeritsForm.find(
      (item: any) => item.id === id,
    );
    if (found) {
      found.isModified = true;
      found.condamnation = e.target.value;
    }
    setCorrectionalJudgementOnMeritsForm([
      ...correctionalJudgementOnMeritsForm,
    ]);
  };

  const handleCorrectionalSelectChange = (id: number | undefined) => (
    e: React.ChangeEvent<{ value: unknown }>,
  ) => {
    const found = correctionalJudgementOnMeritsForm.find(
      (item: any) => item.id === id,
    );
    if (found) {
      found.isModified = true;
      found.suedPartyId = e.target.value;
    }
    setCorrectionalJudgementOnMeritsForm([
      ...correctionalJudgementOnMeritsForm,
    ]);
  };

  const handleMedExpertiseChange = (id: number) => (
    expertiseId: number,
    type: number,
    incidentType: string,
    incident?: any,
  ) => (e: React.ChangeEvent<{ value: string; name: string }>) => {
    const civilJudgementOnMeritsFormMedicalExpertiseData = [
      ...civilJudgementOnMeritsFormMedicalExpertise,
    ];
    const civilJudgementMed = civilJudgementOnMeritsFormMedicalExpertise.find(
      (item: any) => item.id === id,
    );
    const civilJudgementOnMeritsFormAccountingExpertiseData = [
      ...civilJudgementOnMeritsFormAccountingExpertise,
    ];
    const civilJudgementData = [...civilJudgements];

    const accountingExp = allJudgementDocuments
      .map((el: any) => {
        const victimExpertise = get(el, 'expertises', [])
          .filter(
            (item: any) => String(item.expertiseId) === COMPTABLE_EXPERTISE_ID,
          )
          .flatMap((expertise: any) => expertise.victims)
          .find((victim: VictimType) => victim.id === incident.id);
        return {
          id: el.id,
          expertiseJudgementAddDocumentId: get(
            victimExpertise,
            'expertiseJudgementAddDocumentId',
          ),
          victimId: get(victimExpertise, 'id'),
        };
      })
      .find((item: any) => !!item?.expertiseJudgementAddDocumentId);
    const accountingCivj = civilJudgements.find(
      (item: any) => item.judgementAddDocumentId === get(accountingExp, 'id'),
    );
    const medExp = civilJudgementMed.medExpertises.find(
      (item: any) => item.id === expertiseId,
    );
    if (isEmpty(medExp) && e?.target.name) {
      addNewCivjJudgement(
        id,
        civilJudgementData,
        expertiseId,
        civilJudgementOnMeritsFormMedicalExpertiseData,
        e,
        CIVIL_JUDGEMENT_TYPES.MEDICAL,
        incidentType,
      );
      !isEmpty(accountingExp) &&
        featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        addNewCivjJudgement(
          get(accountingCivj, 'id') as any,
          civilJudgements,
          `${get(accountingExp, 'victimId')}-${get(
            accountingExp,
            'expertiseJudgementAddDocumentId',
          )}`,
          civilJudgementOnMeritsFormAccountingExpertiseData,
          e,
          CIVIL_JUDGEMENT_TYPES.ACCOUNTING,
          incidentType,
          incident,
        );
      setCivilJudgementOnMeritsFormMedicalExpertise(
        civilJudgementOnMeritsFormMedicalExpertiseData,
      );
      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
      setCivilJudgements(civilJudgementData);
    } else if (!isEmpty(medExp)) {
      const civjWithoutCompensation = [...civjvmRequest];

      featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        addAccountingExpertiseAfterMerge(
          civilJudgements,
          civilJudgementOnMeritsFormAccountingExpertiseData,
          medExp,
          type,
          e,
          civjWithoutCompensation,
          setCivjvmRequest,
          accountingExp,
        );
      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
      setCivilJudgementOnMeritsFormMedicalExpertise([
        ...civilJudgementOnMeritsFormMedicalExpertise.filter(
          (el: any) => el.id !== civilJudgementMed.id,
        ),
        {
          id: civilJudgementMed.id,
          medExpertises: [
            ...civilJudgementMed.medExpertises.filter(
              (el: any) => el.id !== medExp.id,
            ),
            {
              ...medExp,
              id: medExp.id,
              compensationAmount:
                type === 0
                  ? e.target.value.replace(',', '.')
                  : medExp.compensationAmount,
              evaluationAmount:
                type === 2
                  ? e.target.value.replace(',', '.')
                  : medExp.evaluationAmount,
              provisionalExecution:
                type === 1
                  ? e.target.value.replace(',', '.')
                  : medExp.provisionalExecution,
            },
          ],
        },
      ]);
    }
  };

  const [
    judgementOnMeritsFormDocument,
    setJudgementOnMeritsFormDocument,
  ] = useState({ ...EMPTY_JUDGEMENT_ON_MERITS_DOC });

  const handleAccExpertiseChange = (id: number) => (
    expertiseId: number,
    type: number,
    incidentType: string,
  ) => (e: React.ChangeEvent<{ value: string; name: string }>) => {
    const civilJudgementOnMeritsFormAccountingExpertiseData = [
      ...civilJudgementOnMeritsFormAccountingExpertise,
    ];
    const civilJudgementData = [...civilJudgements];

    const civilJudgement = civilJudgementOnMeritsFormAccountingExpertise.find(
      (item: any) => item.id === id,
    );
    const accExp = civilJudgement.accExpertises.find(
      (item: any) => item.id === expertiseId,
    );
    if (isEmpty(accExp) && e?.target.name) {
      addNewCivjJudgement(
        id,
        civilJudgements,
        expertiseId,
        civilJudgementOnMeritsFormAccountingExpertiseData,
        e,
        CIVIL_JUDGEMENT_TYPES.ACCOUNTING,
        incidentType,
      );
      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
      setCivilJudgements(civilJudgementData);
    } else if (!isEmpty(accExp))
      setCivilJudgementOnMeritsFormAccountingExpertise([
        ...civilJudgementOnMeritsFormAccountingExpertise.filter(
          (el: any) => el.id !== civilJudgement.id,
        ),
        {
          id: civilJudgement.id,
          accExpertises: [
            ...civilJudgement.accExpertises.filter(
              (el: any) => el.id !== accExp.id,
            ),
            {
              ...accExp,
              id: accExp.id,
              evaluationAmount: type ? accExp.evaluationAmount : e.target.value,
              provisionalExecution:
                type !== 1 ? accExp.provisionalExecution : e.target.value,
              calculatedRevenue:
                type !== 2 ? accExp.calculatedRevenue : e.target.value,
            },
          ],
        },
      ]);
  };

  const handleMechanicalExpertiseChange = (id: number) => (
    expertiseId: number,
    type: number,
    incidentType: string,
    incident: any,
  ) => (e: React.ChangeEvent<{ value: string; name: string }>) => {
    const civilJudgementOnMeritsFormMechanicalExpertiseData = [
      ...civilJudgementOnMeritsFormMechanicalExpertise,
    ];
    const civilJudgementOnMeritsFormAccountingExpertiseData = [
      ...civilJudgementOnMeritsFormAccountingExpertise,
    ];
    const civilJudgementData = [...civilJudgements];

    const civilJudgementMec = civilJudgementOnMeritsFormMechanicalExpertise.find(
      (item: any) => item.id === id,
    );
    const accountingExp = allJudgementDocuments
      .map((el: any) => {
        const vehicleExpertise = get(el, 'expertises', [])
          .filter(
            (item: any) => String(item.expertiseId) === COMPTABLE_EXPERTISE_ID,
          )
          .flatMap((expertise: any) => expertise.vehicules)
          .find((vehicle: any) => vehicle.id === incident.id);

        return {
          id: el.id,
          expertiseJudgementAddDocumentId: get(
            vehicleExpertise,
            'expertiseJudgementAddDocumentId',
          ),
          vehiculeId: get(vehicleExpertise, 'id'),
        };
      })
      .find((item: any) => !!item?.expertiseJudgementAddDocumentId);

    const accountingCivj = civilJudgements.find(
      (item: any) => item.judgementAddDocumentId === get(accountingExp, 'id'),
    );
    const meceExp = civilJudgementMec.mechanicalExpertise.find(
      (item: any) => item.id === expertiseId,
    );
    if (isEmpty(meceExp) && e?.target.name) {
      addNewCivjJudgement(
        id,
        civilJudgementData,
        expertiseId,
        civilJudgementOnMeritsFormMechanicalExpertiseData,
        e,
        CIVIL_JUDGEMENT_TYPES.MECHANICAL,
        incidentType,
        incident,
      );
      !isEmpty(accountingExp) &&
        featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        addNewCivjJudgement(
          get(accountingCivj, 'id') as any,
          civilJudgements,
          `${get(accountingExp, 'vehiculeId')}-${get(
            accountingExp,
            'expertiseJudgementAddDocumentId',
          )}`,
          civilJudgementOnMeritsFormAccountingExpertiseData,
          e,
          CIVIL_JUDGEMENT_TYPES.ACCOUNTING,
          incidentType,
          incident,
        );
      setCivilJudgementOnMeritsFormMechanicalExpertise([
        ...civilJudgementOnMeritsFormMechanicalExpertiseData,
      ]);
      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
      setCivilJudgements(civilJudgementData);
    } else if (!isEmpty(meceExp)) {
      featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
        updateVehicleAccountingExpertiseAfterMerge(
          civilJudgements,
          civilJudgementOnMeritsFormAccountingExpertiseData,
          meceExp,
          type,
          e,
          accountingExp,
        );

      setCivilJudgementOnMeritsFormAccountingExpertise(
        civilJudgementOnMeritsFormAccountingExpertiseData,
      );
      setCivilJudgementOnMeritsFormMechanicalExpertise([
        ...civilJudgementOnMeritsFormMechanicalExpertise.filter(
          (el: any) => el.id !== civilJudgementMec.id,
        ),
        {
          id: civilJudgementMec.id,
          mechanicalExpertise: [
            ...civilJudgementMec.mechanicalExpertise.filter(
              (el: any) => el.id !== meceExp.id,
            ),
            {
              ...meceExp,
              id: meceExp.id,
              damageAmount: type ? meceExp.damageAmount : e.target.value,
              provisionalExecution: !type
                ? meceExp.provisionalExecution
                : e.target.value,
            },
          ],
        },
      ]);
    }
  };

  const handleCivilResponsabilityShareChange = (id: number | undefined) => (
    e: React.ChangeEvent<{ value: string }>,
  ) => {
    const found = civilJudgementOnMeritsForm.find(
      (item: any) => item.id === id,
    );
    if (found) {
      found.isModified = true;
      found.responsibilityShare = e.target.value;
    }
    setCivilJudgementOnMeritsForm([...civilJudgementOnMeritsForm]);
    setResponsibilityRate(e.target.value);
  };

  const handleJudgementOnMeritsDocChange = (document: JudgementOnMeritsDoc) =>
    setJudgementOnMeritsRequest(
      Object.assign(
        {},
        { ...judgementOnMeritsRequest },
        {
          document,
        },
      ),
    );

  useEffect(() => {
    if (!isEmpty(judgementOnMerits)) {
      const suedParties =
        get(
          judgementOnMerits['judgementOnMerits']['jom']['cj'],
          'suedPartys',
        ) &&
        get(
          judgementOnMerits['judgementOnMerits']['jom']['cj'],
          'suedPartys',
        ).map(el => {
          return {
            id: el.id,
            condamnation: el.condamnation,
            suedPartyId: el.suedPartyId,
            isModified: false,
          };
        });
      const responsabilityShares = judgementOnMerits['judgementOnMerits'][
        'jom'
      ]['civjs'].map(el => {
        return {
          id: el.id,
          responsibilityShare: el.responsibilityShare,
          isModified: false,
        };
      });
      const civjVictimAccountings = civilJudgements
        .flatMap((item: any) => item.civjacce)
        .filter((el: any) => !!el.victim);

      const medicalExpertises = judgementOnMerits['judgementOnMerits']['jom'][
        'civjs'
      ].map(el => {
        const medExpertises = el['civjmede'].map((item: any) => {
          const accountingExpertise =
            civjVictimAccountings.find(el => el.victimId === item.victimId) ||
            {};
          return {
            id: item.id,
            compensationAmount: item.compensationAmount,
            provisionalExecution: item.provisionalExecution,
            victimId: item?.victimId,
            expertiseJudgementAddDocumentId:
              item?.expertiseJudgementAddDocumentId,
            evaluationAmount: get(
              accountingExpertise,
              'evaluationAmount',
              null,
            ),
          };
        });
        return {
          id: el.id,
          medExpertises: [...medExpertises],
        };
      });
      const accountingExpertises = judgementOnMerits['judgementOnMerits'][
        'jom'
      ]['civjs'].map(el => {
        const accExpertises = el['civjacce'].map((item: any) => {
          return {
            id: item.id,
            evaluationAmount: item.evaluationAmount,
            provisionalExecution: item.provisionalExecution,
            calculatedRevenue: item.calculatedRevenue,
            expertiseJudgementAddDocumentId:
              item?.expertiseJudgementAddDocumentId,
            victimId: get(item, 'victimId', null),
            vehiculeId: get(item, 'vehiculeId', null),
          };
        });
        return {
          id: el.id,
          accExpertises: [...accExpertises],
        };
      });
      const mechanicalExpertises = judgementOnMerits['judgementOnMerits'][
        'jom'
      ]['civjs'].map(el => {
        const mechanicalExpertise = get(el, 'civjmece', []).map((item: any) => {
          return {
            id: item.id,
            damageAmount: item.damageAmount,
            provisionalExecution: item.provisionalExecution,
            expertiseJudgmentAddDocumentId:
              item?.expertiseJudgmentAddDocumentId,
            vehiculeId: item?.vehiculeId,
          };
        });
        return {
          id: el.id,
          mechanicalExpertise: [...mechanicalExpertise],
        };
      });
      if (suedParties) {
        setCorrectionalJudgementOnMeritsForm([...suedParties]);
      }
      setCivilJudgementOnMeritsForm([...responsabilityShares]);
      setCivilJudgementOnMeritsFormMedicalExpertise([...medicalExpertises]);
      setCivilJudgementOnMeritsFormAccountingExpertise([
        ...accountingExpertises,
      ]);
      setCivilJudgementOnMeritsFormMechanicalExpertise([
        ...mechanicalExpertises,
      ]);
    } else {
      const responsabilityShares = get(
        judgementOnMeritsRequest,
        'civjs',
        [],
      ).map((el: any) => {
        return {
          id: el.id,
          responsibilityShare: el.responsibilityShare,
          isModified: false,
        };
      });
      const medicalExpertises = get(judgementOnMeritsRequest, 'civjs', []).map(
        (el: any) => {
          const medExpertises = get(el, 'civjmede', []).map((item: any) => {
            return {
              id: item.id,
              compensationAmount: item.compensationAmount,
              provisionalExecution: item.provisionalExecution,
            };
          });
          return {
            id: el.id,
            medExpertises: [...medExpertises],
          };
        },
      );
      const accountingExpertises = get(
        judgementOnMeritsRequest,
        'civjs',
        [],
      ).map((el: any) => {
        const accExpertises = get(el, 'civjacce', []).map((item: any) => {
          return {
            id: item.id,
            evaluationAmount: item.evaluationAmount,
            provisionalExecution: item.provisionalExecution,
            calculatedRevenue: item.calculatedRevenue,
          };
        });
        return {
          id: el.id,
          accExpertises: [...accExpertises],
        };
      });
      const mechanicalExpertises = get(
        judgementOnMeritsRequest,
        'civjs',
        [],
      ).map((el: any) => {
        return {
          id: el.id,
          mechanicalExpertise: get(el, 'civjmece', []),
        };
      });
      setCivilJudgementOnMeritsForm([...responsabilityShares]);
      setCivilJudgementOnMeritsFormMedicalExpertise([...medicalExpertises]);
      setCivilJudgementOnMeritsFormAccountingExpertise([
        ...accountingExpertises,
      ]);
      setCivilJudgementOnMeritsFormMechanicalExpertise([
        ...mechanicalExpertises,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [judgementOnMerits, props.judiciaryProcessId]);

  const handleClick = () => {
    handleCreateJudgementOnMerits(true);
  };

  const handleCivJvmChange = (
    id: any | null,
    fieldName: string,
    victim?: any,
  ) => (
    event: React.ChangeEvent<{ name?: string | undefined; value: any }>,
  ) => {
    const civilJudgementVictims = [...civjvmRequest];

    let victimToUpdate: any = civjvmRequest.find((el: any) => el.id === id);
    if (id === null) return setCivjvmRequest([...civjvmRequest]);
    if (isEmpty(victimToUpdate) && victim && event.target.name) {
      const substrings = id.split('-');
      addNewJudgementNonCompensation(
        civilJudgementVictims,
        event,
        substrings,
        get(judgementOnMerits, 'judgementOnMerits.jom.id'),
        get(listings, 'civilJudgementVictimReason', []),
        victim,
        INCIDENT_TYPE.VICTIM,
      );
    }

    const index = civilJudgementVictims.findIndex(
      (item: any) => item.id === id,
    );
    if (index !== -1) {
      civilJudgementVictims[index] = {
        ...victimToUpdate,
        [fieldName]: event.target.value,
        responsibilityShare: sharedResponsability,
        otherReason: !hasOtherReason(
          get(listings, 'civilJudgementVictimReason', []),
          get(victimToUpdate, CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON, ''),
        )
          ? null
          : fieldName === CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON
          ? event.target.value
          : null,
      };
    }

    setCivjvmRequest(civilJudgementVictims);
  };

  const handleCivjVehicleChange = (
    id: any,
    fieldName: string,
    vehicle?: any,
  ) => (
    event: React.ChangeEvent<{ name?: string | undefined; value: any }>,
  ) => {
    let vehicleToUpdate: any =
      get(judgementOnMeritsRequest, 'civjVehicle', []).find(
        (el: any) => el?.id === id,
      ) || {};

    const civilJudgementVehicles = [
      ...get(judgementOnMeritsRequest, 'civjVehicle', []),
    ] as any;
    const index = civilJudgementVehicles.findIndex(
      (item: any) => item.id === id,
    );

    if (isEmpty(vehicleToUpdate) && event.target.name) {
      const substrings = id.split('-');
      addNewJudgementNonCompensation(
        civilJudgementVehicles,
        event,
        substrings,
        get(judgementOnMerits, 'judgementOnMerits.jom.id'),
        get(listings, 'civilJudgementVictimReason', []),
        vehicle,
        INCIDENT_TYPE.VEHICLE,
      );
    }
    if (index !== -1) {
      civilJudgementVehicles[index] = {
        ...vehicleToUpdate,
        [fieldName]: event.target.value,
        responsibilityShare: sharedResponsability,
        otherReason: !hasOtherReason(
          get(listings, 'civilJudgementVictimReason', []),
          get(vehicleToUpdate, CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON, ''),
        )
          ? null
          : fieldName === CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON
          ? event.target.value
          : null,
      };
    }
    setJudgementOnMeritsRequest({
      ...judgementOnMeritsRequest,
      civjVehicle: civilJudgementVehicles,
    });
  };

  const handleCreateJudgementOnMerits = (withFeeNote: boolean) => {
    const victimsEvaluationsToInclude = [
      ...getJomVictims([get(currentJom, 'judgementOnMerits', {})]),
      ...getDeceasedJomVictims([currentJom], props.judgementAddClone),
      ...get(currentJom, 'judgementOnMerits.jom.civjvm', []).map(
        (el: any) => el.victimId,
      ),
    ];
    const sagisEvaluationsWithoutExpertise = mapSagisEvaluationsWithoutExpertise(
      judgementOnMeritsRequest,
      judgementOnMerits,
      judgementOnMeritsInfo,
      judgement,
      sharedResponsability,
      get(listings, 'civilJudgementVictimReason', []),
      judgementAddDocuments,
      get(props, 'victims', []),
      judgementAddAppeal,
      props.expertiseReport,
      props.claim,
      props.judiciaryProcessId,
      dahirAmount,
    );
    const nextOfKins = formatNextOfKins(beneficiaries, sharedResponsability);
    const sagisEvaluations = mapSagisEvaluations(
      allVictimExpertises,
      desceasedVictim,
      isMultiple,
      isFirst,
      victimsEvaluationsToInclude,
      judgementOnMeritsRequest,
      judgement,
      judgementOnMeritsInfo,
      civilJudgementOnMeritsForm,
      responsibilityRate,
      get(listings, 'civilJudgementVictimReason', []),
      get(props, 'victims', []),
      props.judiciaryProcessId,
      props.claim,
      props.expertiseReport,
      dahirAmount,
    );
    const sagisEvalVictimKeys =
      sagisEvaluations && sagisEvaluations.map((el: any) => el?.victimKey);
    const civilDocumentsEvaluations = mapCivilDocumentsEvaluations(
      desceasedVictim,
      victims,
      beneficiaries,
      sagisEvalVictimKeys,
      isMultiple,
      isFirst,
      victimsEvaluationsToInclude,
      judgementOnMeritsRequest,
      judgementOnMeritsInfo,
      get(listings, 'civilJudgementVictimReason', []),
      get(props, 'victims', []),
      props.judiciaryProcessId,
      props.claim,
    );
    const civilDocumentsVictimKeys =
      civilDocumentsEvaluations &&
      civilDocumentsEvaluations.map((el: any) => el.victimKey);
    const judiciaryProcessEvaluations = mapVictimToJudiciaryEvaluation(
      filtredCvilProceeding,
      beneficiaries,
      sagisEvalVictimKeys,
      civilDocumentsVictimKeys,
      isMultiple as any,
      isFirst as any,
      victimsEvaluationsToInclude,
      victims,
      desceasedVictim,
      judgementOnMeritsRequest,
      judgementOnMeritsInfo,
      get(listings, 'civilJudgementVictimReason', []),
      get(props, 'victims', []),
      props.judiciaryProcessId,
      props.claim,
    );

    const reasonWithoutCompensationEvaluations = mapReasonWithoutCompensationEvaluations(
      judgementOnMeritsRequest,
      victims,
      sharedResponsability,
      judgementOnMeritsInfo,
      get(listings, 'civilJudgementVictimReason', []),
      get(props, 'victims', []),
      props.claim,
      props.judiciaryProcessId,
      props.expertiseReport,
      dahirAmount,
    );

    setIsButtonRedirect && setIsButtonRedirect(true);
    const sagisEvals = [
      ...mergeEvaluationsV2(
        [
          ...sagisEvaluations,
          ...civilDocumentsEvaluations,
          ...judiciaryProcessEvaluations,
        ],
        sharedResponsability,
      ),
    ];

    const jomRequest = {
      ...judgementOnMeritsRequest,
      civjvm: Object.values(get(judgementOnMeritsRequest, 'civjvm'))
        .filter((item: any) => !isEmpty(item))
        .map((el: any) => ({
          ...el,
          responsibilityShare: parseFloat(sharedResponsability),
        })),
      civjs: get(judgementOnMeritsRequest, 'civjs', []).map((el: any) => ({
        ...el,
        responsibilityShare: parseFloat(sharedResponsability as any),
      })),
      civjVehicle: Object.values(
        get(judgementOnMeritsRequest, 'civjVehicle'),
      ).filter((item: any) => !isEmpty(item)),
      jmv: props.isManager
        ? getJudgementOnMeritsVictims(
            !isEmpty(judgementOnMerits)
              ? civilJudgements
              : get(judgementOnMeritsRequest, 'civjs', []),
            judgementOnMerits,
            props.judgementAddClone,
            judgementAddAppeal,
            filtredCvilProceeding,
            dahirAmountByVictimKey,
            parseFloat(sharedResponsability),
            get(judgementOnMeritsRequest, 'jmv', []),
            [],
            jomDeceasedVictims,
            isMultiple,
          )
        : get(judgementOnMeritsRequest, 'jmv', []),
    };

    requestCreateJudgementOnMerits(
      {
        jom: {
          ...jomRequest,
          ...judgementOnMeritsInfo,
          judgementNumber: formatCourtFileNumber(
            judgementOnMeritsInfo.judgementNumber,
          ),
          lawyerCode: !props.isManager
            ? currentIntervenantStorage.get() &&
              currentIntervenantStorage.get().sagis_code
            : undefined,
        },
        isInboxesActive: featureService.hasFeature(
          FEATURES.ATTRIBUTION_INBOXES_MANAGER,
        ),
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
        isTransactionActive: featureService.hasFeature(FEATURES.TRANSACTION),
        claimId,
        isJudiciaryProcessCorrectional:
          get(filtredCvilProceeding, 'procedureNatureId') === 3,
        isCivilJudgementDefined:
          isCivilJudgementDefined(
            get(props.judgementAddClone, 'judgementAddDocuments', []),
          ) ||
          isCivilJudgementDefined(
            get(judgementAddAppeal, 'judgementAddDocuments', []),
          ),
        claimNumber,
        isCompanyIntervenants: formatIntervenants(
          assignedLawyersByJudiciaryProcess,
        ),
        invoiceFeeNoteInfos:
          !isEmpty(invoiceFeeNoteInfos) &&
          props.isManager &&
          featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE)
            ? formatInvoiceFeeNoteInfos(invoiceFeeNoteInfos)
            : [],
        step: LEGAL_PROCEEDINGS_STEPS.JUDGEMENT_ON_MERITS,
        status: resolveStatus(
          get(filtredCvilProceeding, 'procedureNatureId', 0),
          props.isManager,
          featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER),
        ),
        nextOfKins: props.isManager && nextOfKins,
        deceasedVictims: desceasedVictim.map((el: any) => ({
          ...el,
          responsibilityShare: parseFloat(sharedResponsability as any),
        })),
        beneficiaries: checkVictimExistanceCivilParty(
          desceasedVictim as any,
          victims,
        ).includes(true)
          ? beneficiaries.filter((el: any) =>
              isMultiple ? jomDeceasedVictims.includes(el.victimId) : true,
            )
          : [],
        procedureType: PROCEDURE_TYPES.APPEAL,
        sagisEvaluations: props.isManager && [
          ...sagisEvals,
          ...sagisEvaluationsWithoutExpertise.filter(
            (item: any) =>
              !sagisEvals
                .map((el: any) => el.victimKey)
                .includes(item.victimKey),
          ),
          ...reasonWithoutCompensationEvaluations,
        ],
        provisionBody: props.isManager && {
          riskID: get(
            resolveSagisClaim(props.policyInfo),
            'offeredRisks',
            [],
          ).find(
            (element: { riskName: string }) => element.riskName === rcCoporeal,
          )?.riskId,
          date: moment().toISOString(true),
        },
        username: props.isManager
          ? currentUserStorage.get().username
          : currentIntervenantStorage.get().preferred_username,
        fflipFeeNote: withFeeNote
          ? featureService.hasFeature(FEATURES.FEE_NOTE)
          : undefined,
        judiciaryProcessId: props.judiciaryProcessId,
        isManager: props.isManager,
        isLawyer: !props.isManager,
        lawyerFirmReference: lawyerFirmRef,
        assignementId: get(lawyerAssignment, 'id'),
        decisionGenerationFeeNote: decisionGenerationFeeNote,
        feeNote: withFeeNote
          ? {
              step: PROCEDURE_STEPS.ARRET_ON_MERITS,
              codeIntervenant: lawyerInfo.code,
              judgementDate: get(judgementOnMeritsInfo, 'judgementDate', ''),
              firmReference: isNil(lawyerFirmReference)
                ? lawyerFirmRef
                : lawyerFirmReference,
              courtNumber: `${resolveJudiciaryProcessType(
                get(filtredCvilProceeding, 'procedureNatureId'),
              )} ${formatCourtFileNumber(
                get(judgementOnMeritsInfo, 'judgementNumber'),
              )}`,
              invoiceFeeNote:
                featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) &&
                !isAllValuesIsNil({
                  invoiceNumber: invoiceNumber,
                  invoiceDate: invoiceDate,
                  ...invoiceDocument,
                })
                  ? {
                      codeIntervenant: lawyerInfo.code,
                      createdBy:
                        currentIntervenantStorage?.get() &&
                        currentIntervenantStorage?.get()?.preferred_username,
                      invoiceNumber: invoiceNumber,
                      invoiceDate:
                        invoiceDate === 'Invalid date' ? null : invoiceDate,
                      receptionDate: moment().format('YYYY-MM-DD'),
                      ...invoiceDocument,
                      isIndexed: false,
                    }
                  : undefined,
            }
          : undefined,
        isMultiple,
        priorityClaimReasonId:
          priorityReasonClaimId != 4 &&
          featureService.hasFeature(FEATURES.PRIORITY_CLAIM)
            ? priorityClaimReason(
                [
                  ...sagisEvals,
                  ...sagisEvaluationsWithoutExpertise.filter(
                    (item: any) =>
                      !sagisEvals
                        .map((el: any) => el.victimKey)
                        .includes(item.victimKey),
                  ),
                ],
                !isEmpty(
                  get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []),
                )
                  ? get(resolveSagisClaim(props.policyInfo), 'offeredRisks')
                      .map((el: any) => Number(el.riskProvisions))
                      .reduce(
                        (accumulator: any, currentValue: any) =>
                          accumulator + currentValue,
                      )
                  : 0,
                listings,
              )
            : undefined,
        isLawyerInboxesActive: featureService.hasFeature(
          FEATURES.LAWYER_INBOXES,
        ),
      },
      successCallback(withFeeNote),
    );
  };
  const [contestationReasons, setContestationReasons] = useState<
    Set<{
      civilJudgementMedicalExpertiseId: number;
      civilJudgementMechanicalExpertiseId: number;
      civilJudgementAccountingExpertiseId: number;
      contestationReasons: Set<number>;
    }>
  >(new Set());

  const successCallback = (withFeeNote: boolean) => () => {
    if (withFeeNote && !props.isManager) {
      toast.success(translate(messages.jomToastSuccess, props));
      return pushTo(PAGES.FEE_NOTE)();
    } else if (!withFeeNote && !props.isManager) {
      return pushTo(PAGES.LAWYER_ASSIGNMENTS)();
    } else if (!featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE)) {
      toast.success(translate(messages.jomToastSuccess, props));
      return pushTo(PAGES.COURT_MANAGER_ASSIGNED_CLAIM)();
    }
    toast.success(translate(messages.jomToastSuccess, props));
  };
  const handleValidateJudgementOnMerits = (updatedInvoiceFeeNotes?: any) => {
    const victimsEvaluationsToInclude = [
      ...getJomVictims([get(currentJom, 'judgementOnMerits', {})]),
      ...getDeceasedJomVictims([currentJom], props.judgementAddClone),
      ...get(currentJom, 'judgementOnMerits.jom.civjvm', []).map(
        (el: any) => el.victimId,
      ),
    ];
    const sagisEvaluationsWithoutExpertise = mapSagisEvaluationsWithoutExpertise(
      judgementOnMeritsRequest,
      judgementOnMerits,
      judgementOnMeritsInfo,
      judgement,
      sharedResponsability,
      get(listings, 'civilJudgementVictimReason', []),
      judgementAddDocuments,
      get(props, 'victims', []),
      judgementAddAppeal,
      props.expertiseReport,
      props.claim,
      props.judiciaryProcessId,
    );
    const sagisEvaluations = mapSagisEvaluations(
      allVictimExpertises,
      desceasedVictim,
      isMultiple,
      isFirst,
      victimsEvaluationsToInclude,
      judgementOnMeritsRequest,
      judgement,
      judgementOnMeritsInfo,
      civilJudgementOnMeritsForm,
      responsibilityRate,
      get(listings, 'civilJudgementVictimReason', []),
      get(props, 'victims', []),
      props.judiciaryProcessId,
      props.claim,
    );
    const sagisEvalVictimKeys =
      sagisEvaluations && sagisEvaluations.map((el: any) => el?.victimKey);
    const civilDocumentsEvaluations = mapCivilDocumentsEvaluations(
      desceasedVictim,
      victims,
      beneficiaries,
      sagisEvalVictimKeys,
      isMultiple,
      isFirst,
      victimsEvaluationsToInclude,
      judgementOnMeritsRequest,
      judgementOnMeritsInfo,
      get(listings, 'civilJudgementVictimReason', []),
      get(props, 'victims', []),
      props.judiciaryProcessId,
      props.claim,
    );
    const civilDocumentsVictimKeys =
      civilDocumentsEvaluations &&
      civilDocumentsEvaluations.map((el: any) => el.victimKey);
    const judiciaryProcessEvaluations = mapVictimToJudiciaryEvaluation(
      filtredCvilProceeding,
      beneficiaries,
      sagisEvalVictimKeys,
      civilDocumentsVictimKeys,
      isMultiple as any,
      isFirst as any,
      victimsEvaluationsToInclude,
      victims,
      desceasedVictim,
      judgementOnMeritsRequest,
      judgementOnMeritsInfo,
      get(listings, 'civilJudgementVictimReason', []),
      get(props, 'victims', []),
      props.judiciaryProcessId,
      props.claim,
    );
    const sagisEvals = [
      ...mergeEvaluationsV2(
        [
          ...sagisEvaluations,
          ...civilDocumentsEvaluations,
          ...judiciaryProcessEvaluations,
        ],
        sharedResponsability,
      ),
    ];

    const contestationType = get(
      listings,
      'judgementOnMeritsContestationTypes',
      [],
    ).find(el => el.id === formContestationValues[CONTESTATION.TYPE])?.title;
    const validationRequest = {
      isLawyer: true,
      isContested: isContestationDrawerOpen,
      contestation: {},
      invoiceFeeNotes: updatedInvoiceFeeNotes,
      claimId: Number(claimId),
      claimNumber,
      status: PROCEDURE_STATUSES.PENDING,
      claimExtCode: claimNumber,
      judgementDate: moment(
        get(judgementOnMerits, 'judgementOnMerits.jom.judgementDate'),
      ).format('DD/MM/YYYY'),
      judgementId: get(judgementOnMerits['judgementOnMerits'], 'id'),
      info: {
        id: judgementOnMerits['judgementOnMerits']['jom']['id'],
        ...judgementOnMeritsInfoForm,
        ...additionalJudgementOnMeritsInfoForm,
      },
      deceasedVictims: getDeceasedVictim(
        desceasedVictim,
        props.judgementAddClone,
        sharedResponsability as any,
      ),
      jomId: get(judgementOnMerits, 'judgementOnMerits.jom.id', ''),
      beneficiaries,
      document: {
        ...judgementOnMeritsFormDocument,
        judgementOnMeritsId:
          judgementOnMerits['judgementOnMerits']['jom']['id'],
        id:
          get(judgementOnMerits['judgementOnMerits']['jom'], 'document.id') &&
          get(judgementOnMerits['judgementOnMerits']['jom'], 'document.id'),
      },
      correctionalInfo: [
        ...correctionalJudgementOnMeritsForm.filter((el: any) => el.isModified),
      ],
      civilInfo: [
        ...civilJudgementOnMeritsForm.filter((el: any) => el.isModified),
      ],
      medExpertises: formatMedExpertises(
        civilJudgementOnMeritsFormMedicalExpertise,
      ),
      accExpertises: formatAccExpertises(
        civilJudgementOnMeritsFormAccountingExpertise,
      ),
      mechanicalExpertises: formatMechanicalExpertises(
        civilJudgementOnMeritsFormMechanicalExpertise,
      ),
      isManager: userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER),
      procedureType: PROCEDURE_TYPES.APPEAL,
      fflipFeeNote: false,
      sagisEvaluations: [],
      provisionBody: {},
      judiciaryProcessId: get(
        judgementOnMerits['judgementOnMerits'],
        'judiciaryProcessId',
      ),
      civjvmInfo: civjvmRequest,
      civjVehicleInfo: get(judgementOnMeritsRequest, 'civjVehicle', []),
      isInboxesActive: featureService.hasFeature(
        FEATURES.ATTRIBUTION_INBOXES_MANAGER,
      ),
      isTrackingActive: featureService.hasFeature(
        FEATURES.TRACKING_ACTIONS_USER,
      ),
      jmv: get(
        judgementOnMeritsRequest,
        'jmv',
        [],
      ).filter((item: JudgementOnMeritsVictim) => get(item, 'updated', false)),
      isPriorityActive: featureService.hasFeature(FEATURES.PRIORITY_CLAIM),
      priorityClaimReasonId:
        featureService.hasFeature(FEATURES.PRIORITY_CLAIM) &&
        priorityReasonClaimId != 4
          ? priorityClaimReason(
              [
                ...sagisEvals,
                ...sagisEvaluationsWithoutExpertise.filter(
                  (item: any) =>
                    !sagisEvals
                      .map((el: any) => el.victimKey)
                      .includes(item.victimKey),
                ),
              ],
              !isEmpty(
                get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []),
              )
                ? get(resolveSagisClaim(props.policyInfo), 'offeredRisks')
                    .map((el: any) => Number(el.riskProvisions))
                    .reduce(
                      (accumulator: any, currentValue: any) =>
                        accumulator + currentValue,
                    )
                : 0,
              listings,
            )
          : undefined,
    };

    if (isContestationDrawerOpen) {
      validationRequest.status = PROCEDURE_STATUSES.OPPOSITION;
      validationRequest.contestation = {
        ...formContestationValues,
        victims: selectedVictims,
        beneficiaries: Object.values(selectedBeneficiaries),
        vehicules: selectedVehicles,
        contestationType,
        judgementOnMeritsId: get(
          judgementOnMerits,
          'judgementOnMerits.jom.id',
          '',
        ),
        difficultyExecution: IsDifficultyExecutionChecked,
        defenseExecution: isDefenseExecutionChecked,
      };
    }
    requestValidateJudgementOnMerits &&
      requestValidateJudgementOnMerits(
        validationRequest,
        successCallback(false),
      );
  };
  const handleValidateUpdate = () => {
    if (
      featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE) &&
      !isEmpty(feeNotes) &&
      currentIntervenantStorage.get()
    ) {
      setOpenInvoiceUpdateFeeNoteInfoDialog(true);
    } else {
      handleValidateJudgementOnMerits();
    }
  };
  const handleCloseInvoiceUpdateFeeNote = () => {
    setOpenInvoiceUpdateFeeNoteInfoDialog(false);
  };
  const handleValidateUpdateInvoice = () => {
    const currentItem = feeNotes[currentFeeNoteIndexRef.current];
    const invoiceFeeNoteId = get(currentItem, 'invoiceFeeNote.id');
    const updatedInvoiceFeeNotes = [
      ...invoiceFeeNotes,
      {
        id: invoiceFeeNoteId,
        invoiceNumber: invoiceNumber,
        invoiceDate: invoiceDate,
        receptionDate: moment().format('YYYY-MM-DD'),
        ...invoiceDocument,
      },
    ];
    setInvoiceFeeNotes(updatedInvoiceFeeNotes as any);

    setInvoiceNumber(null);
    setInvoiceDocument({});
    setInvoiceDate(null);
    setOpenInvoiceUpdateFeeNoteInfoDialog(false);
    if (
      updatedInvoiceFeeNotes.length ===
      feeNotes.map((el: any) => el.invoiceFeeNote).length
    ) {
      setCurrentFeeNoteIndex(null);
      handleValidateJudgementOnMerits(updatedInvoiceFeeNotes);
    } else {
      currentFeeNoteIndexRef.current = currentFeeNoteIndexRef.current + 1;
      setCurrentFeeNoteIndex(currentFeeNoteIndexRef.current);
      setOpenInvoiceUpdateFeeNoteInfoDialog(true);
    }
  };

  const onValidate = () => {
    if (
      props.isManager &&
      featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER)
    ) {
      if (
        featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) &&
        !isEmpty(
          extractIntervenant(
            get(listings, 'intervenants'),
            assignedLawyersByJudiciaryProcess,
          ),
        )
      ) {
        return setGenerateFeeNoteLawyer(true);
      } else {
        return handleCreateJudgementOnMerits(true);
      }
    }
    if (
      props.isManager &&
      !featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER)
    ) {
      return handleCreateJudgementOnMerits(false);
    }
    if (isRejected(judgementOnMerits)) {
      if (currentIntervenantStorage.get()) {
        return handleValidateUpdate();
      } else {
        return handleValidateJudgementOnMerits();
      }
    }
    setIsSuccessPopinOpen(true);
  };

  const doNotGenerateFeeNote = () => {
    handleCreateJudgementOnMerits(false);
  };

  const [judgementOnMeritsInfo, setJudgementOnMeritsInfo] = useState({
    judgementNumber: isEmpty(judgementOnMerits)
      ? get(props.judgementAddClone, 'judgementAdd.courtFile', '')
      : get(judgementOnMerits, 'judgementOnMerits.jom.judgementNumber', ''),
    judgementDate: '',
  });
  const [desceasedVictim, setDesceasedVictim] = useState<VictimType[]>([]);
  const validateDesceasedVictim = shouldValidateDesceasedVictims(
    desceasedVictim,
    get(listings, 'civilJudgementVictimReason', []),
    get(judgementOnMeritsRequest, 'jmv', []),
    props,
  );
  const motifListCorrectional = [
    ...getMotifs(
      judgementOnMerits,
      get(listings, LISTINGS.JUDGEMENT_ON_MERITS_CONTESTATION_REASONS, []),
    ),
  ];
  motifListCorrectional.pop();

  const allVictimExpertises = useMemo(() => {
    const victimIds = get(props.expertiseReport, 'victimExpertises', []).map(
      (el: any) => {
        return {
          victimId: el.victimId,
          expertiseId: el.expertiseId,
        };
      },
    );
    const expertiseFirstInstance = get(
      props.expertiseRaportAppeal,
      'victimExpertises',
      [],
    )
      .filter((exp: any) => !exp.isOld && !exp.isRejectedJudgement)
      .filter((item: any) => {
        return !victimIds.some(
          (el: any) =>
            el.victimId === item.victimId &&
            el.expertiseId === item.expertiseId &&
            !el.isOld &&
            !el.isRejectedJudgement,
        );
      })
      .map((el: any) => {
        return {
          ...el,
          isFirstInstance: true,
        };
      });

    const expertReportDefault = get(
      props.expertiseReport,
      'victimExpertises',
      [],
    )
      .filter(
        (expertiseRep: any) =>
          !expertiseRep.isOld && !expertiseRep.isRejectedJudgement,
      )
      .map((e: any) => ({
        ...e,
        isFirstInstance: false,
      }));
    return !isEmpty(expertiseFirstInstance)
      ? [...expertReportDefault, ...expertiseFirstInstance]
      : expertReportDefault;
  }, [props.expertiseReport, props.expertiseRaportAppeal]);

  useEffect(() => {
    const civilProceeding =
      get(props, 'civilProceeding', []).find(
        (cp: any) => cp.id === props.judiciaryProcessId,
      ) || {};
    setVictims(
      props.isCivilProceeding
        ? get(civilProceeding, 'victims', [])
        : get(judgementAddAppeal, 'civilDocuments', [])
            .map((document: any) => get(document, 'victims', []))
            .flat(),
    );
  }, [props.isCivilProceeding, judgementAddAppeal]);

  const allVehiculeExpertises = useMemo(() => {
    const vehicleIds = get(props.expertiseReport, 'vehiculeExpertises', []).map(
      (el: any) => {
        return {
          vehiculeId: el.vehiculeId,
          expertiseId: el.expertiseId,
        };
      },
    );
    const expertiseFirstInstance = get(
      props.expertiseRaportAppeal,
      'vehiculeExpertises',
      [],
    )
      .filter((exp: any) => !exp.isOld && !exp.isRejectedJudgement)
      .filter((item: any) => {
        return !vehicleIds.some(
          (el: any) =>
            el.vehiculeId === item.vehiculeId &&
            el.expertiseId === item.expertiseId &&
            !el.isOld &&
            !el.isRejectedJudgement,
        );
      })
      .map((el: any) => {
        return {
          ...el,
          isFirstInstance: true,
        };
      });

    const expertReportDefault = get(
      props.expertiseReport,
      'vehiculeExpertises',
      [],
    ).filter(
      (expertiseRep: any) =>
        !expertiseRep.isOld && !expertiseRep.isRejectedJudgement,
    );
    return !isEmpty(expertiseFirstInstance)
      ? [...expertReportDefault, ...expertiseFirstInstance]
      : expertReportDefault;
  }, [props.expertiseReport, props.expertiseRaportAppeal]);

  const validateCivilJudgements = validateCivilJudgementsOnRecap(
    filterExpertises(
      formatExpertisesWithExpertReport(
        allJudgementDocuments,
        allVictimExpertises,
        allVehiculeExpertises,
      ),
    ),
    formatExpertisesWithExpertReport(
      allJudgementDocuments,
      allVictimExpertises,
      allVehiculeExpertises,
    ),
    judgement,
    civilJudgementOnMeritsFormMedicalExpertise,
    civilJudgementOnMeritsFormAccountingExpertise,
    civilJudgementOnMeritsFormMechanicalExpertise,
    civjvmRequest,
    get(judgementOnMeritsRequest, 'civjVehicle', []),
    get(listings, 'civilJudgementVictimReason', []),
    [],
    {},
    isCJDisabled,
    judgementOnMerits,
  );

  const [isContestationDrawerOpen, setIsContestationDrawerOpen] = useState(
    false,
  );

  const [formContestationValues, setFormContestationValues] = useState<any>({
    [CONTESTATION.TYPE]: null,
  });

  const [selectedVictims, setSelectedVictims] = useState<any>([]);

  const [selectedBeneficiaries, setSelectedBeneficiaries] = useState<any>({});

  const [selectedVehicles, setSelectedVehicles] = useState<any>([]);

  const [isDefenseExecutionChecked, setIsDefenseExecutionChecked] = useState<
    boolean
  >(false);

  const [
    IsDifficultyExecutionChecked,
    setIsDifficultyExecutionChecked,
  ] = useState<boolean>(false);

  const handleFormChange = (fieldName: string) => (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
  ) =>
    setFormContestationValues(
      Object.assign(
        {},
        { ...formContestationValues },
        { [fieldName]: event.target.value },
      ),
    );

  const IsVictimChecked = (victimId: number, selectedVictims: any): boolean => {
    const found = selectedVictims.find((el: any) => el === victimId);
    if (found) return true;
    return false;
  };

  const handleVictimChangeCheckBox = (victimId: number) => (
    event: React.ChangeEvent<{ value: string; checked: boolean }>,
  ) => {
    const selectedVictim = props.victims.find((el: any) => el.id === victimId);
    if (event.target.checked) {
      setSelectedVictims([...selectedVictims, selectedVictim?.id]);
    } else {
      let uncheckVictimBeneficiaries = { ...selectedBeneficiaries };
      const findBeneficiaryVictim = Object.values(
        uncheckVictimBeneficiaries,
      ).find((beneficiary: any) => beneficiary.victimId === victimId);
      delete uncheckVictimBeneficiaries[
        `${get(findBeneficiaryVictim, 'id', '')}`
      ];
      selectedVictims.splice(
        selectedVictims.findIndex((el: number) => el === victimId),
        1,
      );
      setSelectedVictims([...selectedVictims]);
      setSelectedBeneficiaries(uncheckVictimBeneficiaries);
    }
  };

  const isBeneficiaryChecked = (beneficiaryId: number) =>
    Boolean(
      Object.values(selectedBeneficiaries).find(
        ({ id }: any) => id === beneficiaryId,
      ),
    );

  const handleBeneficiaryCheckBox = (
    victimId: number,
    beneficiaryId: number,
    beneficiaries: [{ id: number; victimId: number }],
  ) => (
    event: React.ChangeEvent<{ id: string; value: string; checked: boolean }>,
  ) => {
    const selectedBeneficiary: any = beneficiaries.find(
      (el: any) => el.id === beneficiaryId,
    );

    if (event.target.checked) {
      setSelectedBeneficiaries({
        ...selectedBeneficiaries,
        ...{
          [selectedBeneficiary.id]: { id: selectedBeneficiary.id, victimId },
        },
      });
    } else {
      let selectedBeneficiary = { ...selectedBeneficiaries };
      delete selectedBeneficiary[
        `${Object.keys(selectedBeneficiary).find(
          (el: any) => Number(el) === beneficiaryId,
        )}`
      ];
      setSelectedBeneficiaries(selectedBeneficiary);
    }
  };

  const IsVehicleChecked = (
    vehicleId: number,
    selectedVehicles: any,
  ): boolean => {
    const found = selectedVehicles.find((el: any) => el === vehicleId);
    if (found) return true;
    return false;
  };

  const handleDifficultyExecutionCheckBox = () => {
    setIsDifficultyExecutionChecked(!IsDifficultyExecutionChecked);
  };

  const handleDefenseExecutionCheckBox = () => {
    setIsDefenseExecutionChecked(!isDefenseExecutionChecked);
  };

  const handleVehicleChangeCheckBox = (vehicleId: number) => (
    event: React.ChangeEvent<{ value: string; checked: boolean }>,
  ) => {
    const selectedVehicle = props.vehicules.find(
      (el: any) => el.id === vehicleId,
    );

    if (event.target.checked) {
      setSelectedVehicles([...selectedVehicles, selectedVehicle.id]);
    } else {
      selectedVehicles.splice(
        selectedVehicles.findIndex((el: number) => el === vehicleId),
        1,
      );
      setSelectedVehicles([...selectedVehicles]);
    }
  };
  const isCreator = props.isManager
    ? currentUserStorage.get()?.username ===
      get(judgementOnMerits, 'judgementOnMerits.creator', '')
    : currentIntervenantStorage.get()?.sagis_code ===
      get(judgementOnMerits, 'judgementOnMerits.lawyerCode', '');

  const handleChangeSharedResponsability = (
    e: React.ChangeEvent<{ value: string }>,
  ) => {
    if (parseFloat(e.target.value) >= 0) {
      setSharedResponsability(e.target.value.replace(',', '.'));
    }
  };

  const handleOpenInvoicesInfoDialog = () => {
    setIsSuccessPopinOpen(false);
    setOpenInvoiceFeeNoteInfoDialog(true);
  };

  const handleCloseSuccessDialog = () => {
    setIsSuccessPopinOpen(false);
    doNotGenerateFeeNote();
  };

  const handleValidateInvoice = () => {
    handleClick();
    setOpenInvoiceFeeNoteInfoDialog(false);
  };

  const handleCloseInvoiceFeeNote = () => {
    setOpenInvoiceFeeNoteInfoDialog(false);
  };

  const handleOpenInvoicesInfoLawyersDialog = () => {
    setGenerateFeeNoteLawyer(false);
    setOpenInvoiceInfoLawyers(true);
  };

  const currentlawyerAssignment =
    claimAssignment.find(
      (el: any) =>
        el.judiciaryProcessId === props.judiciaryProcessId &&
        el.isDeleted === false,
    ) || {};
  return props.isAssignedLawyer ||
    (!props.isAssignedLawyer && !isEmpty(judgementOnMerits)) ? (
    <Container id="judgement-on-merits-wrapper">
      {props.isManager && (
        <div style={{ fontWeight: 'bold', fontSize: '18px', color: 'red' }}>
          {!isUserActive(
            listings,
            get(currentlawyerAssignment, 'assignedLawyer'),
          ) &&
          !isEmpty(currentlawyerAssignment) &&
          !isEmpty(listings)
            ? translate(messages.userNotValidWarning, props, {
                lawyerName: getValueByCode(
                  get(currentlawyerAssignment, 'assignedLawyer', ''),
                  get(listings, 'inactiveIntervenants', []),
                ),
              })
            : ''}
        </div>
      )}
      {props.isManager &&
        isExpertReportWithoutDecision(props.expertiseReport) && (
          <div style={{ fontWeight: 'bold', fontSize: '18px', color: 'red' }}>
            {translate(messages.expertReportWithoutDecision, props)}
          </div>
        )}
      {lawyerAssignment &&
        !isBlockStatusClaim(props.policyInfo) &&
        !props.isManager && (
          <FirmReferenceForm
            firmReference={
              feeNoteAssignment
                ? get(feeNoteAssignment, 'firmReference')
                : lawyerFirmReference
            }
            message={renderMessageFormReference(
              lawyerFirmReference,
              judgementOnMerits,
              feeNoteAssignment,
              props,
            )}
            formInputLabel={translate(
              messages.lawyerFirmReferenceDialogLabel,
              props,
            )}
            formInputName={translate(
              messages.lawyerFirmReferenceDialogLabel,
              props,
            )}
            validationButtonTitle={renderButtonValidationTitle(
              lawyerFirmReference,
              judgementOnMerits,
              feeNoteAssignment,
              props,
            )}
            setIsDialogOpenFirmReference={props.setDialogOpenFirmReference}
            title={
              get(judgementOnMerits, 'judgementOnMerits.creator', '')
                ? translate(messages.creatorTitle, props, {
                    lawyer: get(
                      judgementOnMerits,
                      'judgementOnMerits.creator',
                      '',
                    ),
                  })
                : ''
            }
            isFeeNoteGenerated={feeNoteAssignment}
            isForm={isEmpty(judgementOnMerits)}
            isPronoucing={false}
            feeNote={formatFeeNote(
              lawyerInfo,
              judgementOnMerits,
              filtredCvilProceeding,
              lawyerFirmReference,
              claimNumber,
              judgementOnMeritsInfo,
            )}
            isAssignmentDateValid={
              isEmpty(judgementOnMerits) ||
              new Date(lawyerAssignmentDate).getTime() <=
                new Date(
                  get(judgementOnMerits, 'judgementOnMerits.createdAt', null),
                ).getTime()
            }
            lawyerFirmReference={lawyerFirmReference}
            judiciaryProcessId={props.judiciaryProcessId}
            assignment={lawyerAssignment}
          />
        )}
      <div>
        <div className="judgement-on-merits-title">
          {translate(messages.AppealOnMeritsInfoTitle, props)}
          {get(judgementOnMerits, 'judgementOnMerits.rejectionReason', '') &&
            get(judgementOnMerits, 'judgementOnMerits.status', '') ===
              PROCEDURE_STATUSES.REJECTED && (
              <span style={{ marginLeft: '10px', color: COLORS.RED }}>
                {translate(messages.rejectedTitle, props)}
                {` : ${get(
                  judgementOnMerits,
                  'judgementOnMerits.rejectionReason',
                )}`}
              </span>
            )}
        </div>
        {!isRejected(judgementOnMerits) ? (
          <JudgementOnMeritsInfo
            judgementOnMeritsInfo={judgementOnMeritsInfo}
            setJudgementOnMeritsInfo={setJudgementOnMeritsInfo}
            judgementOnMerits={judgementOnMerits}
            judgementAddDocuments={
              isEmpty(judgementAddDocuments)
                ? get(judgementAddAppeal, 'judgementAddDocuments', [])
                : judgementAddDocuments
            }
            judgementAdd={props.judgementAdd}
          />
        ) : (
          <JudgementOnMeritsForm
            judgementOnMeritsInfoForm={judgementOnMeritsInfoForm}
            setJudgementOnMeritsInfoForm={setJudgementOnMeritsInfoForm}
            judgementOnMerits={judgementOnMerits}
          />
        )}
        {!isEmpty(judgementOnMerits) ? (
          <>
            {get(filtredCvilProceeding, 'procedureNatureId') === 3 && (
              <>
                <div className="judgement-on-merits-title">
                  {translate(messages.AppealOnMeritsInfoTitle, props)}
                </div>
                <div className="correctional-judgement">
                  <div>
                    {isRejected(judgementOnMerits) &&
                      judgementOnMerits['judgementOnMerits']['jom'][
                        'cj'
                      ].suedPartys.map((el: ISuedPartyType) => (
                        <>
                          <FormContainer>
                            <div className="condamnation-textfield">
                              <TextField
                                data-testid="condamnation"
                                label={translate(
                                  { ...messages.condamnationFieldTitle },
                                  props,
                                )}
                                onChange={handleCorrectionalCondamnationChange(
                                  el?.id,
                                )}
                                value={
                                  correctionalJudgementOnMeritsForm.find(
                                    (item: any) => item.id === el.id,
                                  )
                                    ? correctionalJudgementOnMeritsForm.find(
                                        (item: any) => item.id === el.id,
                                      ).condamnation
                                    : ''
                                }
                              />
                            </div>
                            <FormControl className="input-fields-1">
                              <InputLabel>
                                {translate(messages.suedPartyTitle, props)}
                              </InputLabel>
                              <Select
                                value={
                                  correctionalJudgementOnMeritsForm.find(
                                    (item: any) => item.id === el.id,
                                  )
                                    ? correctionalJudgementOnMeritsForm.find(
                                        (item: any) => item.id === el.id,
                                      ).suedPartyId
                                    : ''
                                }
                                onChange={handleCorrectionalSelectChange(
                                  el?.id,
                                )}
                              >
                                {!isEmpty(get(listings, 'suedParty', [])) &&
                                  listings.suedParty.map(suedParty => (
                                    <MenuItem
                                      value={suedParty.id}
                                      key={suedParty.id}
                                    >
                                      {suedParty.title}
                                    </MenuItem>
                                  ))}
                              </Select>
                            </FormControl>
                          </FormContainer>
                        </>
                      ))}
                    {!isRejected(judgementOnMerits) &&
                      judgementOnMerits['judgementOnMerits']['jom'][
                        'cj'
                      ].suedPartys.map((el: ISuedPartyType) => (
                        <>
                          <FormContainer>
                            <div className="condamnation-textfield">
                              <TextField
                                label={translate(
                                  { ...messages.condamnationFieldTitle },
                                  props,
                                )}
                                defaultValue={el.condamnation}
                                InputProps={{ readOnly: true }}
                              />
                            </div>
                            <FormControl className="input-fields-1">
                              <InputLabel>
                                {translate(messages.suedPartyTitle, props)}
                              </InputLabel>
                              <Select value={el.suedPartyId} disabled={true}>
                                {!isEmpty(get(listings, 'suedParty', [])) &&
                                  listings.suedParty.map(suedParty => (
                                    <MenuItem
                                      value={suedParty.id}
                                      key={suedParty.id}
                                    >
                                      {suedParty.title}
                                    </MenuItem>
                                  ))}
                              </Select>
                            </FormControl>
                          </FormContainer>
                        </>
                      ))}
                  </div>
                  <div>
                    {!isEmpty(motifListCorrectional) && (
                      <JudgementOnMeritsMotifRecap
                        motifs={getMotifs(
                          judgementOnMerits,
                          get(
                            listings,
                            LISTINGS.JUDGEMENT_ON_MERITS_CONTESTATION_REASONS,
                            [],
                          ),
                        )}
                      />
                    )}
                  </div>
                </div>
              </>
            )}
          </>
        ) : (
          <>
            {get(filtredCvilProceeding, 'procedureNatureId') === 3 && (
              <>
                <div className="judgement-on-merits-title">
                  {translate(messages.correctionalJudgementTitle, props)}
                </div>
                <CorrectionalJudgement
                  listings={listings}
                  judgementOnMerits={judgementOnMerits}
                  handleSuedPartiesChange={handleSuedPartiesChange}
                />
              </>
            )}
          </>
        )}
        {isEmpty(judgementOnMerits) && (
          <>
            <div className="judgement-on-merits-title">
              {translate(messages.sharedResponsability, props)}
            </div>
            <div className="shared-responsability">
              <TextField
                name={'sharedResponsability'}
                data-testId="shared-responsability"
                label={translate(messages.sharedResponsability, props)}
                value={sharedResponsability}
                onChange={handleChangeSharedResponsability}
                className="shared-responsability-field"
                InputProps={{
                  inputProps: {
                    min: 0,
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      {translate(
                        { ...messages.responsibiltySharePercentage },
                        props,
                      )}
                    </InputAdornment>
                  ),
                }}
                type="number"
                error={disableSharedResponsibility(
                  sharedResponsability,
                  beneficiaries,
                  get(judgementOnMeritsRequest, 'civjs', []),
                )}
                helperText={
                  disableSharedResponsibility(
                    sharedResponsability,
                    beneficiaries,
                    get(judgementOnMeritsRequest, 'civjs', []),
                  ) && translate(messages.validateRequiredField, props)
                }
              />
            </div>
          </>
        )}
        {!isEmpty(judgementOnMerits) && civilJudgements && (
          <>
            <div className="judgement-on-merits-title">
              {translate(messages.sharedResponsability, props)}
            </div>
            <div className="shared-responsability">
              <TextField
                name={'sharedResponsability'}
                data-testId="shared-responsability"
                label={translate(messages.sharedResponsability, props)}
                value={sharedResponsability}
                onChange={handleChangeSharedResponsability}
                className="shared-responsability-field"
                InputProps={{
                  inputProps: {
                    min: 0,
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      {translate(
                        { ...messages.responsibiltySharePercentage },
                        props,
                      )}
                    </InputAdornment>
                  ),
                }}
                type="number"
                error={disableSharedResponsibility(
                  sharedResponsability,
                  beneficiaries,
                  get(judgementOnMeritsRequest, 'civjs', []),
                )}
                helperText={
                  disableSharedResponsibility(
                    sharedResponsability,
                    beneficiaries,
                    get(judgementOnMeritsRequest, 'civjs', []),
                  ) && translate(messages.validateRequiredField, props)
                }
              />
            </div>
          </>
        )}
        {!isEmpty(civilJudgementVictims) && (
          <>
            <div className="judgement-on-merits-title">
              {translate(messages.injuredVictim, props)}
            </div>
            <div className="judgement-add-doc">
              {civjvmRequest
                .filter((item: any) => !item.expertiseJudgementAddDocumentId)
                .map((civjvm: any) => {
                  return (
                    <InjuredVictimsRecap
                      listings={listings}
                      judgementOnMeritsRequest={judgementOnMeritsRequest}
                      isManager={userPrivileges.userHasPrivilege(
                        PRIVILEGES.ISCOURTMANAGER,
                      )}
                      modeType={MODE_TYPES.RECAP}
                      judgement={judgement}
                      setJudgement={setJudgement}
                      judgementForNonCompensation={
                        JUDGEMENT_EXPERTISE_TYPES.NON_COMPENSATION
                      }
                      civjvms={civjvmRequest.filter(
                        (item: any) => !item.expertiseJudgementAddDocumentId,
                      )}
                      civjWithNonCompensation={civjvm}
                      handleCivJvmChange={handleCivJvmChange}
                      judgementOnMerits={judgementOnMerits}
                      sagisVictimInfo={props.sagisVictimInfo}
                      victim={{
                        id: get(civjvm, 'victimId'),
                        ...get(civjvm, 'victim', {}),
                      }}
                      expertiseJudgementAddDocumentId={get(
                        civjvm,
                        'expertiseJudgementAddDocumentId',
                      )}
                      civj={{}}
                      setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
                      civjvmRequest={civjvmRequest}
                      setCivjvmRequest={setCivjvmRequest}
                      setCivilJudgements={setCivilJudgements}
                      civilJudgements={civilJudgements}
                      isDisabled={
                        !props.isManager && !isRejected(judgementOnMerits)
                      }
                      dahirAmount={dahirAmountByVictimKey}
                    />
                  );
                })}
            </div>
          </>
        )}
        {!isEmpty(getInjuredVictims(allJudgementDocuments, victims)) && (
          <InjuredVictim
            victims={getInjuredVictims(allJudgementDocuments, victims)}
            judgementOnMerits={judgementOnMerits}
            setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
            judgementOnMeritsRequest={judgementOnMeritsRequest}
            judgementAddDocuments={judgementAddDocuments}
            currentJom={currentJom}
            isMultiple={isMultiple}
            listings={listings}
            sagisVictimInfo={props.sagisVictimInfo}
            setJudgement={setJudgement}
            judgement={judgement}
          />
        )}
        {filterAccountingCivjs(
          civilJudgements,
          civjvmRequest,
          get(judgementOnMeritsRequest, 'civjVehicle', []),
          judgementAddDocuments,
        ).map((civilJudgement: ICivilJudgement, index: number) => (
          <>
            <div className="judgement-add-doc-title">
              {translate(messages.judgementCivilRecap, props, {
                index: index + 1,
                date: props.intl.formatDate(civilJudgement.createdAt, {
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }),
              })}
            </div>
            <div key={civilJudgement.id} className="judgement-add-doc">
              <CivilJudgementRecap
                isRejected={isRejected(judgementOnMerits)}
                listings={listings}
                contestationReasons={contestationReasons}
                setContestationReasons={setContestationReasons}
                civilJudgement={civilJudgement}
                isContested={isContested(judgementOnMerits)}
                dahirAmount={
                  dahirAmountByVictimKey as { [key: string]: number }
                }
                isAppeal
                responsabilityShareValue={
                  civilJudgementOnMeritsForm.find(
                    (item: any) => item.id === civilJudgement.id,
                  )
                    ? civilJudgementOnMeritsForm.find(
                        (item: any) => item.id === civilJudgement.id,
                      ).responsibilityShare
                    : ''
                }
                handleCivilResponsabilityShareChange={handleCivilResponsabilityShareChange(
                  civilJudgement.id,
                )}
                medicalExpertise={civilJudgementOnMeritsFormMedicalExpertise.find(
                  (item: any) => item.id === civilJudgement.id,
                )}
                handleMedExpertiseChange={handleMedExpertiseChange(
                  civilJudgement.id,
                )}
                accountingExpertise={civilJudgementOnMeritsFormAccountingExpertise.find(
                  (item: any) => item.id === civilJudgement.id,
                )}
                handleAccExpertiseChange={handleAccExpertiseChange(
                  civilJudgement.id,
                )}
                civilJudgementMechanicalExpertise={civilJudgementOnMeritsFormMechanicalExpertise.find(
                  (item: any) => item.id === civilJudgement.id,
                )}
                handleMechanicalExpertiseChange={handleMechanicalExpertiseChange(
                  civilJudgement.id,
                )}
                sagisVictimInfo={props.sagisVictimInfo}
                sagisOpposingParties={props.sagisOpposingParties}
                judgementOnMeritsRequest={judgementOnMeritsRequest}
                setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
                judgement={judgement}
                setJudgement={setJudgement}
                civjvmRequest={civjvmRequest}
                handleCivJvmChange={handleCivJvmChange}
                handleCivjVehicleChange={handleCivjVehicleChange}
                judgementOnMerits={judgementOnMerits}
                civilJudgementOnMeritsFormAccountingExpertise={
                  civilJudgementOnMeritsFormAccountingExpertise
                }
                setCivilJudgementOnMeritsFormAccountingExpertise={
                  setCivilJudgementOnMeritsFormAccountingExpertise
                }
                civilJudgementOnMeritsFormMedicalExpertise={
                  civilJudgementOnMeritsFormMedicalExpertise
                }
                setCivilJudgementOnMeritsFormMedicalExpertise={
                  setCivilJudgementOnMeritsFormMedicalExpertise
                }
                civilJudgementOnMeritsFormMechanicalExpertise={
                  civilJudgementOnMeritsFormMechanicalExpertise
                }
                setCivilJudgementOnMeritsFormMechanicalExpertise={
                  setCivilJudgementOnMeritsFormMechanicalExpertise
                }
                setCivjvmRequest={setCivjvmRequest}
                judgementAddDocument={getAppealAddDocument(
                  civilJudgement,
                  judgementAddDocuments,
                  judgementAddAppeal,
                  allVictimExpertises,
                  allVehiculeExpertises,
                )}
                expertiseReport={{
                  victimExpertises: allVictimExpertises,
                  vehiculeExpertises: allVehiculeExpertises,
                }}
                civilJudgements={civilJudgements}
                setCivilJudgements={setCivilJudgements}
                judgementAddDocuments={formatExpertisesWithExpertReport(
                  allJudgementDocuments,
                  allVictimExpertises,
                  allVehiculeExpertises,
                )}
              />
            </div>
          </>
        ))}
        {!isDeceasedVictimsOnly(props.victims) && isEmpty(judgementOnMerits) && (
          <CivilJudgementForm
            judgementOnMeritsRequest={judgementOnMeritsRequest}
            setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
            dahirAmount={dahirAmountByVictimKey}
            judgementOnMerits={judgementOnMerits}
            judgementAddDocuments={judgementAddDocuments}
            isDisabled={isCJDisabled}
            setIsDisabled={setIsCJDisabled}
            judgementAddAppeal={judgementAddAppeal}
            allJudgementDocuments={resolveJudgementAddAppeal(
              allJudgementDocuments,
              isMultiple,
              currentJom,
            )}
            isAppeal
            sharedResponsability={sharedResponsability}
            sagisVictimInfo={props.sagisVictimInfo}
            sagisOpposingParties={props.sagisOpposingParties}
            victims={props.victims}
            injuredVictims={getInjuredVictims(allJudgementDocuments, victims)}
            isMultiple={isMultiple}
            listings={listings}
            setJudgement={setJudgement}
            judgement={judgement}
            expertiseReport={{
              victimExpertises: allVictimExpertises,
              vehiculeExpertises: allVehiculeExpertises,
            }}
          />
        )}

        {isEmpty(judgementOnMerits)
          ? !isEmpty(get(props.judgementAddClone, 'deceasedVictim')) && (
              <DeceasedVictim
                isRecap={false}
                judgementAddAppeal={judgementAddAppeal}
                beneficiairies={beneficiaries}
                judgementAdd={props.judgementAddClone}
                listing={listings}
                desceasedVictims={desceasedVictim}
                handleChangeDesceasedVictim={setDesceasedVictim}
                handleChangeBeneficiaries={setBeneficiaries}
                isContested={isContested(judgementOnMerits)}
                dahirAmount={dahirAmountByVictimKey}
                currentJudiciaryProcess={filtredCvilProceeding}
                victims={props.victims}
                isManager={userPrivileges.userHasPrivilege(
                  PRIVILEGES.ISCOURTMANAGER,
                )}
                judgementOnMerits={judgementOnMerits}
                allVictims={victims}
                jomDeceasedVictims={jomDeceasedVictims}
                isMultiple={isMultiple}
                sharedResponsability={sharedResponsability as any}
                judgementOnMeritsRequest={judgementOnMeritsRequest}
                setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
                dahirAmountByVictimKey={dahirAmountByVictimKey}
                lossDate={get(claimRecap, 'claim.lossDate')}
              />
            )
          : (!isEmpty(judgementOnMerits['beneficiaries']) ||
              !isEmpty(get(props.judgementAddClone, 'deceasedVictim'))) && (
              <DeceasedVictim
                beneficiairies={beneficiaries}
                judgementAddAppeal={judgementAddAppeal}
                isRecap={true}
                judgementAdd={props.judgementAddClone}
                listing={listings}
                handleChangeDesceasedVictim={setDesceasedVictim}
                desceasedVictims={desceasedVictim}
                handleChangeBeneficiaries={setBeneficiaries}
                RecapInfo={judgementOnMerits['beneficiaries']}
                isContested={isContested(judgementOnMerits)}
                dahirAmount={dahirAmountByVictimKey}
                currentJudiciaryProcess={filtredCvilProceeding}
                victims={props.victims}
                isManager={userPrivileges.userHasPrivilege(
                  PRIVILEGES.ISCOURTMANAGER,
                )}
                judgementOnMerits={judgementOnMerits}
                allVictims={victims}
                jomDeceasedVictims={jomDeceasedVictims}
                isMultiple={isMultiple}
                sharedResponsability={sharedResponsability as any}
                judgementOnMeritsRequest={judgementOnMeritsRequest}
                setJudgementOnMeritsRequest={setJudgementOnMeritsRequest}
                dahirAmountByVictimKey={dahirAmountByVictimKey}
              />
            )}
        <div className="judgement-on-merits-title">
          {translate(messages.judgementOnMeritsAdditionalInfo, props)}
        </div>
        {isRejected(judgementOnMerits) && (
          <AdditionalInfoJudgementOnMeritForm
            additionalJudgementOnMeritsInfoForm={
              additionalJudgementOnMeritsInfoForm
            }
            judgementOnMeritsFormDocument={judgementOnMeritsFormDocument}
            setJudgementOnMeritsFormDocument={setJudgementOnMeritsFormDocument}
            setAdditionalJudgementOnMeritsInfoForm={
              setAdditionalJudgementOnMeritsInfoForm
            }
            judgementOnMerits={judgementOnMerits}
            resetUploadedDocument={resetUploadedDocument}
            uploadDocument={uploadDocument}
            handleJudgementOnMeritsDocChange={() => {}}
            uploadedDocument={uploadedDocument}
            setDocumentId={setDocumentId}
            documentId={documentId}
            requestAddJudgementOnMeritsSupportDocument={
              props.requestAddJudgementOnMeritsSupportDocument
            }
            claimId={claimId}
            claimNumber={claimNumber}
            isCivilProceeding={props.isCivilProceeding}
            isAssignedLawyer={props.isAssignedLawyer}
            isCreator={isCreator}
            claim={props.claim}
            judiciaryProcessId={props.judiciaryProcessId}
            imagineDocuments={props.imagineDocuments}
            policyInfo={props.policyInfo}
            listings={listings}
            isConsultation={props.isConsultation}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
        )}
        {!isRejected(judgementOnMerits) && (
          <AdditionalInfoJudgementOnMerit
            judgementOnMeritsInfo={judgementOnMeritsInfo}
            setJudgementOnMeritsInfo={setJudgementOnMeritsInfo}
            judgementOnMerits={judgementOnMerits}
            resetUploadedDocument={resetUploadedDocument}
            uploadDocument={uploadDocument}
            uploadedDocument={uploadedDocument}
            handleJudgementOnMeritsDocChange={handleJudgementOnMeritsDocChange}
            setDocumentId={setDocumentId}
            documentId={documentId}
            isManager={props.isManager}
            requestAddJudgementOnMeritsSupportDocument={
              props.requestAddJudgementOnMeritsSupportDocument
            }
            claimId={claimId}
            claimNumber={claimNumber}
            isAssignedLawyer={props.isAssignedLawyer}
            isCreator={isCreator}
            imagineDocuments={props.imagineDocuments}
            listings={listings}
            policyInfo={props.policyInfo}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
        )}
      </div>
      {(isEmpty(judgementOnMerits) ||
        (isRejected(judgementOnMerits) && isCreator)) &&
        !userPrivileges.userHasPrivilege(
          PRIVILEGES.ISCOURTMONITORINGMANAGER,
        ) && (
          <>
            <section className="submit-form">
              <SecondaryButton
                title={translate(messages.goBackButton, props)}
                data-testid="go-back"
              />
              <PrimaryButton
                disabled={
                  !isEmpty(judgementOnMerits)
                    ? disableOnValidationButton(
                        judgementOnMeritsInfoForm,
                        validateDesceasedVictim,
                        getAllBeneficiaries(desceasedVictim),
                        validateCivilJudgements,
                        sharedResponsability,
                        civilJudgementOnMeritsFormMedicalExpertise,
                        civilJudgementOnMeritsFormAccountingExpertise,
                        civilJudgementOnMeritsFormMechanicalExpertise,
                        get(listings, 'civilJudgementVictimReason', []),
                        get(judgementOnMeritsRequest, 'civjs', []),
                        victims,
                        civjvmRequest,
                        allJudgementDocuments,
                      )
                    : disableValidationButton(
                        judgementOnMerits,
                        filtredCvilProceeding,
                        judgementOnMeritsRequest,
                        props.isCivilProceeding,
                        judgementOnMeritsInfo,
                        isCJDisabled,
                        isRejected(judgementOnMerits),
                        allJudgementDocuments,
                        sharedResponsability,
                        beneficiaries,
                        validateDesceasedVictim,
                        get(listings, 'civilJudgementVictimReason', []),
                        victims,
                        isExpertReportWithoutDecision(props.expertiseReport),
                        props.isManager,
                        [
                          ...Object.values(
                            get(judgementOnMeritsRequest, 'civjvm'),
                          ),
                          ...getCivjvmInJudgement(props.appealOnMeritsMultiple),
                        ],
                      )
                }
                data-testid="validate"
                background={BUTTON_COLORS.PRIMARY_BLUE}
                border={BUTTON_COLORS.PRIMARY_BLUE}
                titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                title={translate(messages.validateButton, props)}
                onClick={onValidate}
              />
            </section>
            {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) ? (
              <InvoiceFeeNoteDialog
                open={isSuccessPopinOpen}
                onClose={() => setIsSuccessPopinOpen(false)}
                decisionGenerationFeeNote={decisionGenerationFeeNote}
                setDecisionGenerationFeeNote={setDecisionGenerationFeeNote}
                handleValidate={
                  decisionGenerationFeeNote
                    ? handleOpenInvoicesInfoDialog
                    : handleCloseSuccessDialog
                }
                shouldDisplayFirmReferenceField={
                  isEmpty(lawyerFirmReference) && !props.isManager
                }
                setLawyerFirmRef={setLawyerFirmRef}
                lawyerFirmRef={lawyerFirmRef}
              />
            ) : (
              <SuccessDialog
                title={translate(messages.successDialogTitle, props)}
                secondaryButtonTitle={translate(
                  messages.successDialogSecondaryButtonTitle,
                  props,
                )}
                primaryButtonTitle={
                  featureService.hasFeature(FEATURES.FEE_NOTE)
                    ? translate(
                        messages.successDialogPrimaryButtonTitleJdd,
                        props,
                      )
                    : translate(messages.successDialogPrimaryButtonTitle, props)
                }
                tertiaryButtonTitle={translate(
                  { ...messages.doNotGenerateFeeNote },
                  props,
                )}
                onTertiaryClick={doNotGenerateFeeNote}
                open={isSuccessPopinOpen && !props.isManager}
                onClose={setIsSuccessPopinOpen}
                onPrimaryClick={handleClick}
                homePath={PAGES.LAWYER_HOME}
                isExpertReport={false}
                isPrimaryButtonDisabled={isEmpty(lawyerFirmReference)}
              />
            )}
            {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) && (
              <InvoiceInfoDialog
                open={openInvoiceFeeNoteInfoDialog}
                onClose={handleCloseInvoiceFeeNote}
                handleValidate={handleValidateInvoice}
                invoiceNumber={invoiceNumber}
                invoiceDate={invoiceDate}
                setInvoiceNumber={setInvoiceNumber}
                setInvoiceDate={setInvoiceDate}
                resetUploadedDocument={resetUploadedDocument}
                uploadDocument={uploadDocument}
                uploadedDocument={uploadedDocument}
                invoiceDocument={invoiceDocument}
                setInvoiceDocument={setInvoiceDocument}
                limitInvoiceDate={getLimitInvoiceIntervenant(
                  get(listings, 'appConfig', []),
                )}
              />
            )}
          </>
        )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) &&
        props.isManager && (
          <InvoiceFeeNoteDialog
            open={generateFeeNoteLawyer}
            onClose={() => setGenerateFeeNoteLawyer(false)}
            decisionGenerationFeeNote={decisionGenerationFeeNote}
            setDecisionGenerationFeeNote={setDecisionGenerationFeeNote}
            handleValidate={
              decisionGenerationFeeNote
                ? handleOpenInvoicesInfoLawyersDialog
                : () => {
                    setInvoiceFeeNoteInfo([]);
                    handleCreateJudgementOnMerits(false);
                    setGenerateFeeNoteLawyer(false);
                  }
            }
            shouldDisplayFirmReferenceField={
              isEmpty(lawyerFirmReference) && !props.isManager
            }
            setLawyerFirmRef={setLawyerFirmRef}
            lawyerFirmRef={lawyerFirmRef}
          />
        )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) && (
        <DynamiqDialog
          open={openInvoiceInfoLawyers}
          onClose={() => setOpenInvoiceInfoLawyers(false)}
          handleValidate={() => {
            handleCreateJudgementOnMerits(true);
            setOpenInvoiceInfoLawyers(false);
          }}
          children={
            <>
              {extractIntervenant(
                get(listings, 'intervenants'),
                assignedLawyersByJudiciaryProcess,
              )?.map((item: any, index: any) => (
                <div style={{ marginTop: 10 }}>
                  <Typography style={{ fontWeight: 700 }}>
                    {translate(messages.intervenantName, props, {
                      IntervenantName: get(item, 'ItemDescription', null),
                    })}
                  </Typography>
                  <InvoiceFeeNotesManagerDialog
                    invoiceFeeNoteInfo={invoiceFeeNoteInfos[index]}
                    listings={listings}
                    invoiceFeeNoteInfos={invoiceFeeNoteInfos}
                    resetUploadedDocument={resetUploadedDocument}
                    uploadedDocument={uploadedDocument}
                    uploadDocument={uploadDocument}
                    assignedLawyersByJudiciaryProcess={
                      assignedLawyersByJudiciaryProcess
                    }
                    setDocumentId={setDocumentId}
                    setInvoiceFeeNoteInfo={setInvoiceFeeNoteInfo}
                    documentId={documentId}
                    index={index}
                    displayFirmReferenceInput={
                      isNil(get(item, 'firmReference', null)) &&
                      featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE)
                    }
                    limitInvoiceDate={getLimitInvoiceManager(
                      get(listings, 'appConfig', []),
                    )}
                  />
                </div>
              ))}
            </>
          }
        />
      )}
      {!isEmpty(judgementOnMerits) &&
        isEmpty(get(judgementOnMerits, 'judgementOnMerits.jom.jmc', '')) &&
        get(judgementOnMerits, 'judgementOnMerits.status', '') !==
          PROCEDURE_STATUSES.REJECTED &&
        props.isAssignedLawyer && (
          <>
            <section className="submit-form">
              <SecondaryButton
                title={translate(messages.goBackButton, props)}
                data-testid="go-back"
              />
              <PrimaryButton
                data-testid="contestation"
                background={BUTTON_COLORS.PRIMARY_BLUE}
                border={BUTTON_COLORS.PRIMARY_BLUE}
                titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                title={translate(
                  messages.judgementOnMeritsContestationType,
                  props,
                )}
                onClick={() => setIsContestationDrawerOpen(true)}
              />
            </section>
          </>
        )}
      {featureService.hasFeature(FEATURES.JUDGEMENT_ON_MERITS_CONTESTATION) ? (
        <div>
          <SahamDrawer
            open={isContestationDrawerOpen}
            handleToggleDrawer={() => setIsContestationDrawerOpen(false)}
            title={translate(messages.contestationDrawerTitle, props)}
            confirmButtonTitle={translate(messages.validateButton, props)}
            isDisplayCancelButton
            isDisplayCloseButton
            handleValidateDrawer={handleValidateJudgementOnMerits}
          >
            <FormContainer>
              <FormControl className="formEl">
                <InputLabel>
                  {translate(messages.judgementOnMeritsContestationType, props)}
                </InputLabel>
                <Select
                  onChange={handleFormChange(CONTESTATION.TYPE)}
                  name={CONTESTATION.TYPE}
                  data-testid={CONTESTATION.TYPE}
                  id={CONTESTATION.TYPE}
                  value={get(formContestationValues, [CONTESTATION.TYPE], '')}
                >
                  {get(listings, 'judgementOnMeritsContestationTypes', [])
                    .filter(
                      (el: any) =>
                        (el.displayFor === PROCEDURE_TYPES.APPEAL ||
                          isNil(el.displayFor)) &&
                        el.isVisible,
                    )
                    .map((type: Config) => (
                      <MenuItem value={type.id} key={type.id}>
                        {type.title}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </FormContainer>
            {formContestationValues[CONTESTATION.TYPE] === 2 && (
              <FormContainer>
                <FormControl className="formEl">
                  <InputLabel>
                    {translate(
                      messages.judgementOnMeritsContestationWithdrawalReason,
                      props,
                    )}
                  </InputLabel>
                  <Select
                    onChange={handleFormChange(CONTESTATION.WITHDRAWALREASON)}
                    name={CONTESTATION.WITHDRAWALREASON}
                    value={get(
                      formContestationValues,
                      [CONTESTATION.WITHDRAWALREASON],
                      '',
                    )}
                  >
                    {get(
                      listings,
                      'judgementOnMeritsContestationWithdrawalReasons',
                      [],
                    ).map((type: Config) => (
                      <MenuItem value={type.id} key={type.id}>
                        {type.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </FormContainer>
            )}
            <FormContainer>
              <FormControl className="formEl">
                <InputLabel>
                  {translate(
                    messages.judgementOnMeritsContestationOwner,
                    props,
                  )}
                </InputLabel>
                <Select
                  onChange={handleFormChange(CONTESTATION.OWNER)}
                  name={CONTESTATION.OWNER}
                  value={get(formContestationValues, [CONTESTATION.OWNER], '')}
                >
                  {get(listings, 'judgementOnMeritsContestationOwners', []).map(
                    (type: Config) => (
                      <MenuItem value={type.id} key={type.id}>
                        {type.title}
                      </MenuItem>
                    ),
                  )}
                </Select>
              </FormControl>
            </FormContainer>
            <FormContainer>
              <FormControl className="formEl">
                <InputLabel>
                  {translate(
                    messages.judgementOnMeritsContestationAgainst,
                    props,
                  )}
                </InputLabel>
                <Select
                  onChange={handleFormChange(CONTESTATION.AGAINST)}
                  name={CONTESTATION.AGAINST}
                  data-testid={CONTESTATION.AGAINST}
                  value={get(
                    formContestationValues,
                    [CONTESTATION.AGAINST],
                    '',
                  )}
                >
                  <MenuItem value={CONTESTATION_AGAINST.VICTIM} key={0}>
                    {CONTESTATION_AGAINST.VICTIM}
                  </MenuItem>
                  <MenuItem value={CONTESTATION_AGAINST.VEHICLE} key={1}>
                    {CONTESTATION_AGAINST.VEHICLE}
                  </MenuItem>
                </Select>
              </FormControl>
            </FormContainer>
            {formContestationValues[CONTESTATION.AGAINST] ===
              CONTESTATION_AGAINST.VICTIM && (
              <FormContainer>
                <FormGroup>
                  {props.victims.map((victim: VictimType) => (
                    <div>
                      <FormControlLabel
                        key={victim.id}
                        control={
                          <Checkbox
                            data-testid="checkboxId"
                            checked={IsVictimChecked(
                              victim.id as any,
                              selectedVictims,
                            )}
                            color="primary"
                            onChange={handleVictimChangeCheckBox(
                              victim.id as any,
                            )}
                          />
                        }
                        label={
                          featureService.hasFeature(
                            FEATURES.MIGRATION_CLAIM_INFO,
                          )
                            ? `${get(
                                getVictimFromSagisInfo(
                                  get(victim, 'victimKey'),
                                  props.sagisVictimInfo,
                                ),
                                'victimFirstName',
                                '',
                              )} ${get(
                                getVictimFromSagisInfo(
                                  get(victim, 'victimKey'),
                                  props.sagisVictimInfo,
                                ),
                                'victimLastName',
                                '',
                              )}`
                            : getVictimFullName(victim)
                        }
                      />

                      {IsVictimChecked(victim.id as any, selectedVictims) &&
                        get(victim, 'beneficiaries', []).map(
                          (beneficiary: any) => (
                            <div style={{ marginLeft: '20px' }}>
                              <div className="info-item">
                                {translate(
                                  {
                                    ...messages.judgementOnMeritsContestationBeneficiaries,
                                  },
                                  props,
                                )}
                              </div>

                              <FormControlLabel
                                key={beneficiary.id}
                                control={
                                  <Checkbox
                                    name="beneficiary"
                                    checked={isBeneficiaryChecked(
                                      beneficiary.id,
                                    )}
                                    color="primary"
                                    onChange={handleBeneficiaryCheckBox(
                                      victim.id as any,
                                      beneficiary.id,
                                      victim.beneficiaries as any,
                                    )}
                                  />
                                }
                                label={`${beneficiary.firstName} ${beneficiary.lastName}`}
                              />
                            </div>
                          ),
                        )}
                    </div>
                  ))}
                </FormGroup>
              </FormContainer>
            )}
            {formContestationValues[CONTESTATION.AGAINST] ===
              CONTESTATION_AGAINST.VEHICLE && (
              <FormContainer>
                <FormGroup>
                  {props.vehicules.map((vehicule: any, index: number) => (
                    <FormControlLabel
                      key={index}
                      control={
                        <Checkbox
                          data-testid="checkboxId"
                          checked={IsVehicleChecked(
                            vehicule.id,
                            selectedVehicles,
                          )}
                          color="primary"
                          onChange={handleVehicleChangeCheckBox(vehicule.id)}
                        />
                      }
                      label={vehicule.registrationNumber}
                    />
                  ))}
                </FormGroup>
              </FormContainer>
            )}
            <FormContainer>
              <FormControl className="formEl">
                <TextField
                  id="commentary"
                  label={translate(
                    {
                      ...messages.judgementOnMeritsContestationCommentary,
                    },
                    props,
                  )}
                  className="formEl"
                  onChange={handleFormChange(CONTESTATION.COMMENTARY)}
                  name={CONTESTATION.COMMENTARY}
                  value={get(formContestationValues, [CONTESTATION.COMMENTARY])}
                />
              </FormControl>
            </FormContainer>
            <FormContainer>
              <FormControl className="formEl">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={IsDifficultyExecutionChecked}
                      color="primary"
                      onChange={handleDifficultyExecutionCheckBox}
                    />
                  }
                  label={translate(
                    messages.judgementOnMeritsContestationDifficultyExecution,
                    props,
                  )}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isDefenseExecutionChecked}
                      color="primary"
                      onChange={handleDefenseExecutionCheckBox}
                    />
                  }
                  label={translate(
                    messages.judgementOnMeritsContestationDefenseExecution,
                    props,
                  )}
                />
              </FormControl>
            </FormContainer>
          </SahamDrawer>
        </div>
      ) : (
        <PrimaryButton
          background={BUTTON_COLORS.PRIMARY_BLUE}
          border={BUTTON_COLORS.PRIMARY_BLUE}
          titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
          title={translate(messages.validateButton, props)}
          onClick={handleValidateUpdate}
        />
      )}
      {featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE) &&
      !isEmpty(feeNotes) &&
      feeNotes ? (
        feeNotes.map((item: FeeNoteType) => (
          <InvoiceInfoDialog
            open={openInvoiceUpdateFeeNoteInfoDialog}
            onClose={handleCloseInvoiceUpdateFeeNote}
            handleValidate={handleValidateUpdateInvoice}
            invoiceNumber={invoiceNumber}
            invoiceDate={invoiceDate}
            setInvoiceNumber={setInvoiceNumber}
            setInvoiceDate={setInvoiceDate}
            resetUploadedDocument={resetUploadedDocument}
            uploadDocument={uploadDocument}
            uploadedDocument={uploadedDocument}
            invoiceDocument={invoiceDocument}
            setInvoiceDocument={setInvoiceDocument}
            displayUpdateTitle={true}
            isManager={false}
            limitInvoiceDate={getLimitInvoiceIntervenant(
              get(listings, 'appConfig', []),
            )}
          />
        ))
      ) : (
        <></>
      )}
    </Container>
  ) : (
    <></>
  );
};

export default injectIntl(JudgementOnMeritsAppeal);
